import type { SVGProps } from "react"
import type { JSX } from "react/jsx-runtime"

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

function withSvg(Path: JSX.Element) {
  return ({ size = 20, color, viewBox = "0 0 24 24", ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} width={size} height={size} fill="none" color={color} {...props}>
      {Path}
    </svg>
  )
}

export const AtomicPower = withSvg(
  <>
    <path
      d="M17.2192 7.375C17.7102 5.67518 17.5723 4.19962 16.6863 3.31363C14.812 1.43925 10.2989 2.91335 6.60614 6.60613C6.21164 7.00061 5.84248 7.40446 5.5 7.81346M14.5 12.1865C14.1575 12.5955 13.7883 12.9994 13.3938 13.3938C9.70108 17.0867 5.18802 18.5607 3.31363 16.6863C2.36308 15.7358 2.27368 14.1067 2.8981 12.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5629 7.75L9.10361 9.47529C8.92544 9.70629 8.83644 9.82179 8.89161 9.91088C8.94677 9.99996 9.10736 9.99996 9.42844 9.99996H10.5723C10.8934 9.99996 11.0539 9.99996 11.1091 10.0891C11.1643 10.1782 11.0752 10.2937 10.8971 10.5247L9.42844 12.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 14.7549C7.60954 14.3428 7.10048 13.8883 6.60613 13.3938C2.91335 9.70108 1.43925 5.18802 3.31363 3.31363C4.26418 2.36308 5.89335 2.27368 7.75 2.8981M11.875 16.9673C13.8859 17.7344 15.6723 17.7004 16.6863 16.6863C18.5607 14.812 17.0867 10.2989 13.3938 6.60614C12.8995 6.11178 12.3905 5.65718 11.875 5.24506"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Clear = withSvg(
  <>
    <path d="M21 3L13 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9.44573 11.0854C6.96539 12.0368 4.98269 11.8736 3 11.0885C3.50059 17.531 6.50414 20.0089 10.5089 21C10.5089 21 13.5261 18.8664 13.961 13.8074C14.0081 13.2595 14.0317 12.9856 13.9178 12.6769C13.8038 12.3682 13.5802 12.1468 13.1329 11.704C12.3973 10.9757 12.0295 10.6116 11.5929 10.5204C11.1564 10.4293 10.5862 10.648 9.44573 11.0854Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 16.4464C4.5 16.4464 7 16.9286 9.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.5 7.25C8.5 7.94036 7.94036 8.5 7.25 8.5C6.55964 8.5 6 7.94036 6 7.25C6 6.55964 6.55964 6 7.25 6C7.94036 6 8.5 6.55964 8.5 7.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M11 4V4.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Fullscreen = withSvg(
  <path
    d="M7.93668 16.0634C7.41936 15.5461 7.50535 13.3483 7.50535 13.3483M7.93668 16.0634C8.45401 16.5808 10.6517 16.4946 10.6517 16.4946M7.93668 16.0634L11 13M16.0634 7.93661C15.5461 7.41928 13.3484 7.50537 13.3484 7.50537M16.0634 7.93661C16.5808 8.45394 16.4946 10.6516 16.4946 10.6516M16.0634 7.93661L13 11"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const Filter = withSvg(
  <>
    <path d="M3 7H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 17H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 17L21 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 7L21 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 7C6 6.06812 6 5.60218 6.15224 5.23463C6.35523 4.74458 6.74458 4.35523 7.23463 4.15224C7.60218 4 8.06812 4 9 4C9.93188 4 10.3978 4 10.7654 4.15224C11.2554 4.35523 11.6448 4.74458 11.8478 5.23463C12 5.60218 12 6.06812 12 7C12 7.93188 12 8.39782 11.8478 8.76537C11.6448 9.25542 11.2554 9.64477 10.7654 9.84776C10.3978 10 9.93188 10 9 10C8.06812 10 7.60218 10 7.23463 9.84776C6.74458 9.64477 6.35523 9.25542 6.15224 8.76537C6 8.39782 6 7.93188 6 7Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 17C12 16.0681 12 15.6022 12.1522 15.2346C12.3552 14.7446 12.7446 14.3552 13.2346 14.1522C13.6022 14 14.0681 14 15 14C15.9319 14 16.3978 14 16.7654 14.1522C17.2554 14.3552 17.6448 14.7446 17.8478 15.2346C18 15.6022 18 16.0681 18 17C18 17.9319 18 18.3978 17.8478 18.7654C17.6448 19.2554 17.2554 19.6448 16.7654 19.8478C16.3978 20 15.9319 20 15 20C14.0681 20 13.6022 20 13.2346 19.8478C12.7446 19.6448 12.3552 19.2554 12.1522 18.7654C12 18.3978 12 17.9319 12 17Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const Settings = withSvg(
  <>
    <path
      d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M21.011 14.0965C21.5329 13.9558 21.7939 13.8854 21.8969 13.7508C22 13.6163 22 13.3998 22 12.9669V11.0332C22 10.6003 22 10.3838 21.8969 10.2493C21.7938 10.1147 21.5329 10.0443 21.011 9.90358C19.0606 9.37759 17.8399 7.33851 18.3433 5.40087C18.4817 4.86799 18.5509 4.60156 18.4848 4.44529C18.4187 4.28902 18.2291 4.18134 17.8497 3.96596L16.125 2.98673C15.7528 2.77539 15.5667 2.66972 15.3997 2.69222C15.2326 2.71472 15.0442 2.90273 14.6672 3.27873C13.208 4.73448 10.7936 4.73442 9.33434 3.27864C8.95743 2.90263 8.76898 2.71463 8.60193 2.69212C8.43489 2.66962 8.24877 2.77529 7.87653 2.98663L6.15184 3.96587C5.77253 4.18123 5.58287 4.28891 5.51678 4.44515C5.45068 4.6014 5.51987 4.86787 5.65825 5.4008C6.16137 7.3385 4.93972 9.37763 2.98902 9.9036C2.46712 10.0443 2.20617 10.1147 2.10308 10.2492C2 10.3838 2 10.6003 2 11.0332V12.9669C2 13.3998 2 13.6163 2.10308 13.7508C2.20615 13.8854 2.46711 13.9558 2.98902 14.0965C4.9394 14.6225 6.16008 16.6616 5.65672 18.5992C5.51829 19.1321 5.44907 19.3985 5.51516 19.5548C5.58126 19.7111 5.77092 19.8188 6.15025 20.0341L7.87495 21.0134C8.24721 21.2247 8.43334 21.3304 8.6004 21.3079C8.76746 21.2854 8.95588 21.0973 9.33271 20.7213C10.7927 19.2644 13.2088 19.2643 14.6689 20.7212C15.0457 21.0973 15.2341 21.2853 15.4012 21.3078C15.5682 21.3303 15.7544 21.2246 16.1266 21.0133L17.8513 20.034C18.2307 19.8187 18.4204 19.711 18.4864 19.5547C18.5525 19.3984 18.4833 19.132 18.3448 18.5991C17.8412 16.6616 19.0609 14.6226 21.011 14.0965Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>
)

export const Users = withSvg(
  <>
    <path
      d="M18.6161 20H19.1063C20.2561 20 21.1707 19.4761 21.9919 18.7436C24.078 16.8826 19.1741 15 17.5 15M15.5 5.06877C15.7271 5.02373 15.9629 5 16.2048 5C18.0247 5 19.5 6.34315 19.5 8C19.5 9.65685 18.0247 11 16.2048 11C15.9629 11 15.7271 10.9763 15.5 10.9312"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.48131 16.1112C3.30234 16.743 0.211137 18.0331 2.09388 19.6474C3.01359 20.436 4.03791 21 5.32572 21H12.6743C13.9621 21 14.9864 20.436 15.9061 19.6474C17.7889 18.0331 14.6977 16.743 13.5187 16.1112C10.754 14.6296 7.24599 14.6296 4.48131 16.1112Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13 7.5C13 9.70914 11.2091 11.5 9 11.5C6.79086 11.5 5 9.70914 5 7.5C5 5.29086 6.79086 3.5 9 3.5C11.2091 3.5 13 5.29086 13 7.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const User = withSvg(
  <>
    <path
      d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const Password = withSvg(
  <>
    <path d="M8.5 11L9.5 12M9.5 12L10.5 13M9.5 12L10.5 11M9.5 12L8.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3.5 11L4.5 12M4.5 12L5.5 13M4.5 12L5.5 11M4.5 12L3.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M13.5 11L14.5 12M14.5 12L15.5 13M14.5 12L15.5 11M14.5 12L13.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M18.5 11L19.5 12M19.5 12L20.5 13M19.5 12L20.5 11M19.5 12L18.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M19.6338 16C17.951 18.8033 15.1069 20.6217 13.406 21.5194C12.7989 21.8398 12.4954 22 12 22C11.5046 22 11.2011 21.8398 10.594 21.5194C8.89306 20.6217 6.04902 18.8033 4.36621 16M20.9999 8C20.9986 6.54505 20.9763 5.7889 20.5959 5.28529C20.1918 4.75029 19.2781 4.49056 17.4507 3.9711C16.2022 3.6162 15.1016 3.18863 14.2223 2.79829C13.0234 2.2661 12.424 2 12 2C11.576 2 10.9766 2.2661 9.77771 2.79829C8.89839 3.18863 7.79784 3.61619 6.54933 3.9711C4.72193 4.49056 3.80822 4.75029 3.40411 5.28529C3.02371 5.7889 3.00139 6.54505 3.00008 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>
)

export const Logout = withSvg(
  <>
    <path
      d="M14 3.09502C13.543 3.03241 13.0755 3 12.6 3C7.29807 3 3 7.02944 3 12C3 16.9706 7.29807 21 12.6 21C13.0755 21 13.543 20.9676 14 20.905"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M21 12L11 12M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Chat = withSvg(
  <>
    <path d="M8 13.5H16M8 8.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>
)

export const Time = withSvg(
  <>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9.5 9.5L12.9999 12.9996M16 8L11 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Timer = withSvg(
  <>
    <path
      d="M11.0809 13.152L8 7L13.4196 11.2796C14.1901 11.888 14.1941 13.0472 13.4277 13.6607C12.6614 14.2743 11.5189 14.0266 11.0809 13.152Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 4.82C3.14864 6.63902 2 9.17385 2 11.9776C2 17.5129 6.47715 22.0001 12 22.0001C17.5228 22.0001 22 17.5129 22 11.9776C22 7.1242 18.5581 3.07656 13.9872 2.15288C13.1512 1.98394 12.7332 1.89947 12.3666 2.20022C12 2.50097 12 2.98714 12 3.95949V4.96175"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Send = withSvg(
  <>
    <path
      d="M21.0477 3.05293C18.8697 0.707363 2.48648 6.4532 2.50001 8.551C2.51535 10.9299 8.89809 11.6617 10.6672 12.1581C11.7311 12.4565 12.016 12.7625 12.2613 13.8781C13.3723 18.9305 13.9301 21.4435 15.2014 21.4996C17.2278 21.5892 23.1733 5.342 21.0477 3.05293Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M11.5 12.5L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Warning = withSvg(
  <>
    <path
      d="M5.32171 9.68293C7.73539 5.41199 8.94222 3.27651 10.5983 2.72681C11.5093 2.4244 12.4907 2.4244 13.4017 2.72681C15.0578 3.27651 16.2646 5.41199 18.6783 9.68293C21.092 13.9538 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6548 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6548 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9538 5.32171 9.68293Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M11.9919 16H12.0009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 13V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Info = withSvg(
  <>
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.9919 8H12.0009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Tick = withSvg(<path d="M5 14L8.5 17.5L19 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />)

export const Check = withSvg(
  <>
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M8 12.5L10.5 15L16 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Close = withSvg(
  <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
)

export const Eye = withSvg(
  <>
    <path
      d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const EyeOff = withSvg(
  <>
    <path
      d="M19.439 15.439C20.3636 14.5212 21.0775 13.6091 21.544 12.955C21.848 12.5287 22 12.3155 22 12C22 11.6845 21.848 11.4713 21.544 11.045C20.1779 9.12944 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M6.74742 6.74742C4.73118 8.1072 3.24215 9.94266 2.45604 11.045C2.15201 11.4713 2 11.6845 2 12C2 12.3155 2.15201 12.5287 2.45604 12.955C3.8221 14.8706 7.31078 19 12 19C13.9908 19 15.7651 18.2557 17.2526 17.2526"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M3 3L21 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const MenuExpendLeftLine = withSvg(
  <path d="M20 8H11M20 12H4M4 12L7 9M4 12L7 15M20 16H11" stroke="#777" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
)

export const Sun01 = withSvg(
  <>
    <path
      d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M11.9955 3H12.0045M11.9961 21H12.0051M18.3588 5.63599H18.3678M5.63409 18.364H5.64307M5.63409 5.63647H5.64307M18.3582 18.3645H18.3672M20.991 12.0006H21M3 12.0006H3.00898"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Notification03 = withSvg(
  <>
    <path
      d="M2.52992 14.394C2.31727 15.7471 3.268 16.6862 4.43205 17.1542C8.89481 18.9486 15.1052 18.9486 19.5679 17.1542C20.732 16.6862 21.6827 15.7471 21.4701 14.394C21.3394 13.5625 20.6932 12.8701 20.2144 12.194C19.5873 11.2975 19.525 10.3197 19.5249 9.27941C19.5249 5.2591 16.1559 2 12 2C7.84413 2 4.47513 5.2591 4.47513 9.27941C4.47503 10.3197 4.41272 11.2975 3.78561 12.194C3.30684 12.8701 2.66061 13.5625 2.52992 14.394Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 21C9.79613 21.6219 10.8475 22 12 22C13.1525 22 14.2039 21.6219 15 21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const FilterVertical = withSvg(
  <>
    <path d="M7 21L7 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 21L17 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 6L17 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 9L7 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7 18C6.06812 18 5.60218 18 5.23463 17.8478C4.74458 17.6448 4.35523 17.2554 4.15224 16.7654C4 16.3978 4 15.9319 4 15C4 14.0681 4 13.6022 4.15224 13.2346C4.35523 12.7446 4.74458 12.3552 5.23463 12.1522C5.60218 12 6.06812 12 7 12C7.93188 12 8.39782 12 8.76537 12.1522C9.25542 12.3552 9.64477 12.7446 9.84776 13.2346C10 13.6022 10 14.0681 10 15C10 15.9319 10 16.3978 9.84776 16.7654C9.64477 17.2554 9.25542 17.6448 8.76537 17.8478C8.39782 18 7.93188 18 7 18Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M17 12C16.0681 12 15.6022 12 15.2346 11.8478C14.7446 11.6448 14.3552 11.2554 14.1522 10.7654C14 10.3978 14 9.93188 14 9C14 8.06812 14 7.60218 14.1522 7.23463C14.3552 6.74458 14.7446 6.35523 15.2346 6.15224C15.6022 6 16.0681 6 17 6C17.9319 6 18.3978 6 18.7654 6.15224C19.2554 6.35523 19.6448 6.74458 19.8478 7.23463C20 7.60218 20 8.06812 20 9C20 9.93188 20 10.3978 19.8478 10.7654C19.6448 11.2554 19.2554 11.6448 18.7654 11.8478C18.3978 12 17.9319 12 17 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const Point = withSvg(<circle cx="12" cy="12" r="2" fill="currentColor" />)

export const CheckmarkCircle02 = withSvg(
  <>
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M8 12.5L10.5 15L16 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const File01 = withSvg(
  <>
    <path
      d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 7H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 11H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Arrow = withSvg(
  <path
    d="M8.24374 10.2569C8.03957 10.461 8.03957 10.7902 8.24374 10.9944L11.7062 14.4569C11.8687 14.6194 12.1312 14.6194 12.2937 14.4569L15.7562 10.9944C15.9604 10.7902 15.9604 10.461 15.7562 10.2569C15.5521 10.0527 15.2229 10.0527 15.0187 10.2569L11.9979 13.2735L8.97707 10.2527C8.77707 10.0527 8.44374 10.0527 8.24374 10.2569V10.2569Z"
    fill="currentColor"
  />
)

export const Logout01 = withSvg(
  <>
    <path
      d="M14 3.09502C13.543 3.03241 13.0755 3 12.6 3C7.29807 3 3 7.02944 3 12C3 16.9706 7.29807 21 12.6 21C13.0755 21 13.543 20.9676 14 20.905"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M21 12L11 12M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const ChartRing = withSvg(
  <>
    <path d="M9 9L5 5M16 12H22M12 16V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
  </>
)

export const DarkMode = withSvg(
  <path
    d="M23.0279 15.7767C22.905 15.6686 22.7247 15.6474 22.5778 15.722C18.3731 17.8682 13.2129 16.4407 10.8319 12.4718C8.45101 8.50294 9.74584 3.48909 13.7798 1.05717C13.9208 0.972323 13.9912 0.811064 13.9554 0.654917C13.9198 0.498513 13.7859 0.380444 13.621 0.360255C11.0072 0.0369701 8.41887 0.537103 6.13434 1.80673C3.37101 3.34137 1.39424 5.82083 0.568375 8.78712C-0.25749 11.7534 0.16633 14.8516 1.76203 17.5112C3.35746 20.1708 5.93358 22.0732 9.01584 22.868C10.0451 23.1333 11.0895 23.2646 12.1273 23.2646C14.1973 23.2646 16.2404 22.7423 18.081 21.7195C20.365 20.4504 22.1097 18.5429 23.1257 16.203C23.1899 16.0553 23.1506 15.8848 23.0279 15.7767Z"
    fill="currentColor"
  />
)

export const Loader = withSvg(
  <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
    <circle cx="25" cy="25" r="20" fill="transparent" strokeWidth="5" strokeOpacity="0.1" />
    <path d="M45 25c0-11.046-8.954-20-20-20" strokeWidth="5" strokeLinecap="round" stroke="#237AD2" fill="transparent">
      <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.9s" repeatCount="indefinite" />
    </path>
  </svg>
)

export const Location = withSvg(
  <>
    <path
      d="M4 17C2.17107 17.4117 1 18.0443 1 18.7537C1 19.9943 4.58172 21 9 21C13.4183 21 17 19.9943 17 18.7537C17 18.0443 15.8289 17.4117 14 17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.5 8C11.5 9.38071 10.3807 10.5 9 10.5C7.61929 10.5 6.5 9.38071 6.5 8C6.5 6.61929 7.61929 5.5 9 5.5C10.3807 5.5 11.5 6.61929 11.5 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.2574 16.4936C9.92012 16.8184 9.46932 17 9.00015 17C8.53099 17 8.08018 16.8184 7.7429 16.4936C4.6543 13.5008 0.51519 10.1575 2.53371 5.30373C3.6251 2.67932 6.24494 1 9.00015 1C11.7554 1 14.3752 2.67933 15.4666 5.30373C17.4826 10.1514 13.3536 13.5111 10.2574 16.4936Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const NoticeIcon = withSvg(
  <>
    <path
      d="M1.5 10.5C1.5 6.02166 1.5 3.78249 2.89124 2.39124C4.28249 1 6.52166 1 11 1C15.4783 1 17.7175 1 19.1088 2.39124C20.5 3.78249 20.5 6.02166 20.5 10.5C20.5 14.9783 20.5 17.2175 19.1088 18.6088C17.7175 20 15.4783 20 11 20C6.52166 20 4.28249 20 2.89124 18.6088C1.5 17.2175 1.5 14.9783 1.5 10.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10 6L16 6M7 6C7 6.27614 6.77614 6.5 6.5 6.5C6.22386 6.5 6 6.27614 6 6C6 5.72386 6.22386 5.5 6.5 5.5C6.77614 5.5 7 5.72386 7 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.5H16M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 15H16M7 15C7 15.2761 6.77614 15.5 6.5 15.5C6.22386 15.5 6 15.2761 6 15C6 14.7239 6.22386 14.5 6.5 14.5C6.77614 14.5 7 14.7239 7 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Copy = withSvg(
  <>
    <path
      d="M1 11.4C1 8.38301 1 6.87452 1.94627 5.93726C2.89254 5 4.41554 5 7.46154 5H8.53846C11.5845 5 13.1075 5 14.0537 5.93726C15 6.87452 15 8.38301 15 11.4V14.6C15 17.617 15 19.1255 14.0537 20.0627C13.1075 21 11.5845 21 8.53846 21H7.46154C4.41554 21 2.89254 21 1.94627 20.0627C1 19.1255 1 17.617 1 14.6V11.4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M14.5376 15H15.4608C18.072 15 19.3776 15 20.1888 14.1799C21 13.3598 21 12.0399 21 9.4V6.6C21 3.96013 21 2.6402 20.1888 1.8201C19.3776 1 18.072 1 15.4608 1H14.5376C11.9264 1 10.6208 1 9.80959 1.8201C9.10022 2.53726 9.01118 3.63664 9 5.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M5 11H8M5 16H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9.5 2L13.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </>
)

export const Sun02 = withSvg(
  <>
    <path
      d="M6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7455 3C10.7455 2.30964 11.3052 1.75 11.9955 1.75H12.0045C12.6948 1.75 13.2545 2.30964 13.2545 3C13.2545 3.69036 12.6948 4.25 12.0045 4.25H11.9955C11.3052 4.25 10.7455 3.69036 10.7455 3ZM17.1088 5.63599C17.1088 4.94563 17.6684 4.38599 18.3588 4.38599H18.3678C19.0581 4.38599 19.6178 4.94563 19.6178 5.63599C19.6178 6.32634 19.0581 6.88599 18.3678 6.88599H18.3588C17.6684 6.88599 17.1088 6.32634 17.1088 5.63599ZM4.38409 5.63647C4.38409 4.94612 4.94373 4.38647 5.63409 4.38647H5.64307C6.33342 4.38647 6.89307 4.94612 6.89307 5.63647C6.89307 6.32683 6.33342 6.88647 5.64307 6.88647H5.63409C4.94373 6.88647 4.38409 6.32683 4.38409 5.63647ZM1.75 12.0006C1.75 11.3102 2.30964 10.7506 3 10.7506H3.00898C3.69933 10.7506 4.25898 11.3102 4.25898 12.0006C4.25898 12.6909 3.69933 13.2506 3.00898 13.2506H3C2.30964 13.2506 1.75 12.6909 1.75 12.0006ZM19.741 12.0006C19.741 11.3102 20.3007 10.7506 20.991 10.7506H21C21.6904 10.7506 22.25 11.3102 22.25 12.0006C22.25 12.6909 21.6904 13.2506 21 13.2506H20.991C20.3007 13.2506 19.741 12.6909 19.741 12.0006ZM4.38409 18.364C4.38409 17.6737 4.94373 17.114 5.63409 17.114H5.64307C6.33342 17.114 6.89307 17.6737 6.89307 18.364C6.89307 19.0544 6.33342 19.614 5.64307 19.614H5.63409C4.94373 19.614 4.38409 19.0544 4.38409 18.364ZM17.1082 18.3645C17.1082 17.6741 17.6679 17.1145 18.3582 17.1145H18.3672C19.0575 17.1145 19.6172 17.6741 19.6172 18.3645C19.6172 19.0549 19.0575 19.6145 18.3672 19.6145H18.3582C17.6679 19.6145 17.1082 19.0549 17.1082 18.3645ZM10.7461 21C10.7461 20.3096 11.3057 19.75 11.9961 19.75H12.0051C12.6954 19.75 13.2551 20.3096 13.2551 21C13.2551 21.6904 12.6954 22.25 12.0051 22.25H11.9961C11.3057 22.25 10.7461 21.6904 10.7461 21Z"
      fill="currentColor"
    />
  </>
)

export const SelectArrow = withSvg(
  <path
    d="M21.0847 9.32833L12.6003 17.1052C12.5216 17.1776 12.428 17.2349 12.325 17.274C12.222 17.3132 12.1116 17.3333 12.0001 17.3333C11.8886 17.3333 11.7782 17.3132 11.6752 17.274C11.5722 17.2349 11.4786 17.1776 11.3998 17.1052L2.91539 9.32833C2.75619 9.18241 2.66675 8.98449 2.66675 8.77812C2.66675 8.57175 2.75619 8.37383 2.91539 8.22791C3.07459 8.08199 3.29052 8 3.51567 8C3.7408 8 3.95673 8.08199 4.11593 8.22791L12.0001 15.4556L19.8842 8.22791C19.963 8.15565 20.0566 8.09833 20.1597 8.05923C20.2626 8.02012 20.373 8 20.4845 8C20.5959 8 20.7063 8.02012 20.8094 8.05923C20.9123 8.09833 21.0059 8.15565 21.0847 8.22791C21.1635 8.30016 21.2261 8.38595 21.2687 8.48035C21.3114 8.57476 21.3334 8.67593 21.3334 8.77812C21.3334 8.88031 21.3114 8.98149 21.2687 9.07589C21.2261 9.17031 21.1635 9.25608 21.0847 9.32833Z"
    fill="currentColor"
  />
)

export const Toggle = withSvg(
  <path d="M20 5H4M20 19H4M4 12H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
)

export const Clock02 = withSvg(
  <>
    <path
      d="M5.048 8.60702L2.538 8.45402C4.338 3.70402 9.503 1.00002 14.54 2.34402C19.904 3.77702 23.09 9.26102 21.657 14.594C20.223 19.926 14.712 23.088 9.347 21.655C7.46089 21.1545 5.76152 20.1152 4.4567 18.6642C3.15188 17.2133 2.29818 15.4135 2 13.485"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 8V12L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Calendar03 = withSvg(
  <>
    <path d="M18 2V4M6 2V4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.9955 13H12.0045M11.9955 17H12.0045M15.991 13H16M8 13H8.00897M8 17H8.00897"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.5 8H20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 8H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const AddCircle = withSvg(
  <>
    <path d="M12 8V16M16 12L8 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const CancelCircle = withSvg(
  <>
    <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const Edit02 = withSvg(
  <>
    <path
      d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M13 4L20 11" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </>
)

export const Energy = withSvg(
  <>
    <path
      d="M19.3352 6.79085C16.9084 3.33525 12.4029 2.03556 8.50846 3.66769C4.61401 5.29982 2.38138 9.42339 3.14342 13.5767"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.4209 19.2101V17.2092H6.42173" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.66504 17.2092C7.09183 20.6648 11.5973 21.9645 15.4917 20.3323C19.3862 18.7002 21.6188 14.5766 20.8568 10.4233"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.5792 4.79004V6.79087H17.5784" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.3302 15.3315L14.0009 12.0001H9.99927L11.67 8.6687"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Delete02 = withSvg(
  <>
    <path
      d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      className="delete-icon-cap"
      d="M16.0557 5.5H8.05292L8.65861 4.17126L8.65861 4.17125C9.10063 3.20155 9.32164 2.7167 9.71729 2.41317C9.80498 2.3459 9.8981 2.28601 9.99568 2.23412C10.436 2 10.9688 2 12.0345 2C13.0741 2 13.5939 2 14.027 2.2247C14.1231 2.27454 14.215 2.3321 14.3017 2.39681C14.6928 2.68852 14.9196 3.15626 15.3731 4.09173L16.0557 5.5Z"
      fill="currentColor"
    />
    <path
      d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M9.5 16.5L9.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14.5 16.5L14.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </>
)

export const TrashIcon = withSvg(
  <>
    <path
      d="M14.625 4.125L14.1602 11.6438C14.0415 13.5648 13.9821 14.5253 13.5006 15.2159C13.2625 15.5573 12.956 15.8455 12.6005 16.062C11.8816 16.5 10.9192 16.5 8.99456 16.5C7.06734 16.5 6.10373 16.5 5.38429 16.0612C5.0286 15.8443 4.722 15.5556 4.48401 15.2136C4.00266 14.5219 3.94459 13.5601 3.82846 11.6364L3.375 4.125"
      stroke="#DB2777"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.0418 4.125H6.03969L6.49395 3.12844C6.82547 2.40116 6.99123 2.03752 7.28797 1.80988C7.35374 1.75942 7.42357 1.71451 7.49676 1.67559C7.82699 1.5 8.22662 1.5 9.0259 1.5C9.80559 1.5 10.1954 1.5 10.5203 1.66853C10.5923 1.70591 10.6612 1.74907 10.7263 1.7976C11.0196 2.01639 11.1897 2.36719 11.5298 3.0688L12.0418 4.125Z"
      fill="#DB2777"
    />
    <path
      d="M2.25 4.125H15.75M12.0418 4.125L11.5298 3.0688C11.1897 2.36719 11.0196 2.01639 10.7263 1.7976C10.6612 1.74907 10.5923 1.70591 10.5203 1.66853C10.1954 1.5 9.80559 1.5 9.0259 1.5C8.22662 1.5 7.82699 1.5 7.49676 1.67559C7.42357 1.71451 7.35374 1.75942 7.28797 1.80988C6.99123 2.03753 6.82547 2.40116 6.49395 3.12844L6.03969 4.125"
      stroke="#DB2777"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M7.125 12.375L7.125 7.875" stroke="#DB2777" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10.875 12.375L10.875 7.875" stroke="#DB2777" strokeWidth="1.5" strokeLinecap="round" />
  </>
)

export const Store01 = withSvg(
  <>
    <path
      d="M2 10L2 14.5C2 17.3284 2 18.7426 2.87868 19.6213C3.75736 20.5 5.17157 20.5 8 20.5H14C16.8284 20.5 18.2426 20.5 19.1213 19.6213C20 18.7426 20 17.3284 20 14.5V10"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.97071 8L7.6952 7.80605C7.59787 7.44245 7.2461 7.20732 6.87291 7.2564C6.49971 7.30549 6.22071 7.62359 6.22071 8H6.97071ZM1.11347 9.04045L1.8163 8.77865L1.8163 8.77865L1.11347 9.04045ZM20.8865 9.04045L20.1837 8.77865L20.1837 8.77866L20.8865 9.04045ZM15.0293 8H15.7793C15.7793 7.62359 15.5003 7.30549 15.1271 7.2564C14.7539 7.20732 14.4021 7.44245 14.3048 7.80605L15.0293 8ZM1.45767 7.0777L2.10768 7.45185L2.10768 7.45185L1.45767 7.0777ZM2.42134 5.40355L1.77133 5.02939H1.77133L2.42134 5.40355ZM20.5423 7.0777L19.8923 7.45185V7.45185L20.5423 7.0777ZM19.5787 5.40355L20.2287 5.02939V5.02939L19.5787 5.40355ZM20.9873 8.22893L20.2398 8.29116V8.29117L20.9873 8.22893ZM1.01274 8.22893L0.265329 8.16669L1.01274 8.22893ZM6.22071 8C6.22071 9.23749 5.20869 10.25 3.94875 10.25V11.75C6.02678 11.75 7.72071 10.0762 7.72071 8H6.22071ZM3.94875 10.25C2.96882 10.25 2.13568 9.63607 1.8163 8.77865L0.41065 9.30225C0.943544 10.7329 2.32767 11.75 3.94875 11.75V10.25ZM20.1837 8.77866C19.8643 9.63607 19.0312 10.25 18.0513 10.25V11.75C19.6723 11.75 21.0565 10.7329 21.5894 9.30225L20.1837 8.77866ZM18.0513 10.25C16.7913 10.25 15.7793 9.23749 15.7793 8H14.2793C14.2793 10.0762 15.9732 11.75 18.0513 11.75V10.25ZM11 10.25C9.39133 10.25 8.06678 9.1941 7.6952 7.80605L6.24623 8.19395C6.79833 10.2564 8.73155 11.75 11 11.75V10.25ZM14.3048 7.80605C13.9332 9.1941 12.6087 10.25 11 10.25V11.75C13.2685 11.75 15.2017 10.2564 15.7538 8.19395L14.3048 7.80605ZM2.10768 7.45185L3.07134 5.7777L1.77133 5.02939L0.807664 6.70355L2.10768 7.45185ZM21.1923 6.70355L20.2287 5.02939L18.9287 5.7777L19.8923 7.45185L21.1923 6.70355ZM4.91511 2.25H17.0849V0.75H4.91511V2.25ZM19.8086 3.45934C19.8086 1.95786 18.584 0.75 17.0849 0.75V2.25C17.7659 2.25 18.3086 2.79659 18.3086 3.45934H19.8086ZM20.2287 5.02939C19.9532 4.55089 19.8086 4.00972 19.8086 3.45934H18.3086C18.3086 4.27286 18.5224 5.072 18.9287 5.7777L20.2287 5.02939ZM3.69143 3.45934C3.69143 2.79659 4.23412 2.25 4.91511 2.25V0.75C3.41603 0.75 2.19143 1.95786 2.19143 3.45934H3.69143ZM21.5893 9.30225C21.6322 9.18715 21.6943 9.02692 21.726 8.82441C21.7576 8.62312 21.7553 8.41456 21.7347 8.16669L20.2398 8.29117C20.256 8.48553 20.2492 8.55963 20.2442 8.592C20.2393 8.62315 20.2325 8.64756 20.1837 8.77865L21.5893 9.30225ZM19.8923 7.45185C20.1674 7.92967 20.2185 8.03434 20.2398 8.29116L21.7347 8.16669C21.6824 7.53904 21.4614 7.17106 21.1923 6.70355L19.8923 7.45185ZM3.07134 5.7777C3.47755 5.072 3.69143 4.27286 3.69143 3.45934H2.19143C2.19143 4.00972 2.04676 4.55089 1.77133 5.02939L3.07134 5.7777ZM1.8163 8.77865C1.76747 8.64756 1.76074 8.62315 1.75585 8.592C1.75078 8.55963 1.74397 8.48552 1.76016 8.29116L0.265329 8.16669C0.244688 8.41457 0.242397 8.62312 0.273967 8.82441C0.305728 9.02692 0.367777 9.18715 0.41065 9.30225L1.8163 8.77865ZM0.807664 6.70355C0.53856 7.17106 0.317593 7.53904 0.265329 8.16669L1.76016 8.29116C1.78154 8.03434 1.83264 7.92967 2.10768 7.45185L0.807664 6.70355Z"
      fill="currentColor"
    />
    <path d="M6 17H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </>
)

export const Calendar02 = withSvg(
  <>
    <path d="M11 13L16 13M8 13H8.00898M13 17H8M16 17H15.991" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 2V4M6 2L6 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3L12.95 3C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 8L21 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Building02 = withSvg(
  <>
    <path d="M15 2H9C5.69067 2 5 2.69067 5 6V22H19V6C19 2.69067 18.3093 2 15 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M3 22H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 22V19C15 17.3453 14.6547 17 13 17H11C9.34533 17 9 17.3453 9 19V22" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M13.5 6H10.5M13.5 9.5H10.5M13.5 13H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </>
)
export const Building03 = withSvg(
  <>
    <path
      d="M13.334 8.33331L15.1252 8.87065C16.2695 9.21398 16.8417 9.38565 17.1712 9.82848C17.5007 10.2713 17.5007 10.8687 17.5007 12.0634V18.3333"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path d="M6.66602 7.5H9.16602M6.66602 10.8333H9.16602" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10.0007 18.3334V15.8334C10.0007 15.0477 10.0007 14.6549 9.75657 14.4108C9.51248 14.1667 9.11965 14.1667 8.33398 14.1667H7.50065C6.71498 14.1667 6.32214 14.1667 6.07806 14.4108C5.83398 14.6549 5.83398 15.0477 5.83398 15.8334V18.3334"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path d="M1.66602 18.3333H18.3327" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path
      d="M2.5 18.3334V5.59772C2.5 3.50543 2.5 2.45928 3.15932 1.94022C3.81864 1.42116 4.78952 1.70298 6.73127 2.26661L10.8979 3.47604C12.0697 3.81616 12.6556 3.98622 12.9944 4.44973C13.3333 4.91325 13.3333 5.54456 13.3333 6.80716V18.3334"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Building06 = withSvg(
  <>
    <path
      d="M12 2.00039H6C3.518 2.00039 3 2.51839 3 5.00039V22.0004H15V5.00039C15 2.51839 14.482 2.00039 12 2.00039Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M18 8.00039H15V22.0004H21V11.0004C21 8.51839 20.482 8.00039 18 8.00039Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M8.0004 6H10.0004M8.0004 9H10.0004M8.0004 12H10.0004"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5004 21.9996V17.9996C11.5004 17.0568 11.5004 16.5854 11.2075 16.2925C10.9146 15.9996 10.4432 15.9996 9.5004 15.9996H8.5004C7.55759 15.9996 7.08619 15.9996 6.79329 16.2925C6.5004 16.5854 6.5004 17.0568 6.5004 17.9996V21.9996"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </>
)

export const AnalyticsUp = withSvg(
  <>
    <path
      d="M5.83398 15V13.3333M10.0007 15V12.5M14.1673 15V10.8333M2.08398 9.99998C2.08398 6.26803 2.08398 4.40205 3.24335 3.24268C4.40273 2.08331 6.2687 2.08331 10.0007 2.08331C13.7326 2.08331 15.5986 2.08331 16.758 3.24268C17.9173 4.40205 17.9173 6.26803 17.9173 9.99998C17.9173 13.7319 17.9173 15.5979 16.758 16.7573C15.5986 17.9166 13.7326 17.9166 10.0007 17.9166C6.2687 17.9166 4.40273 17.9166 3.24335 16.7573C2.08398 15.5979 2.08398 13.7319 2.08398 9.99998Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.99414 9.57111C6.79006 9.63094 10.8624 9.35986 13.1787 5.68362M11.6609 5.23948L13.2238 4.98793C13.4143 4.96367 13.694 5.11406 13.7627 5.29334L14.176 6.6587"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const SolarEnergy = withSvg(
  <>
    <path
      d="M1.66602 8.33335C2.31575 5.15343 4.72367 2.60779 7.83783 1.7415C8.09924 1.66878 8.22994 1.63242 8.30034 1.71032C8.37077 1.78822 8.31888 1.91704 8.21516 2.17465L7.49935 3.75002M11.666 1.66669C14.8459 2.31642 17.3916 4.72434 18.2578 7.8385C18.3306 8.09991 18.3669 8.23061 18.289 8.30101C18.2112 8.37144 18.0823 8.31955 17.8247 8.21583L16.2493 7.50002M18.3327 11.6667C17.6829 14.8466 15.275 17.3923 12.1608 18.2585C11.8994 18.3313 11.7688 18.3676 11.6983 18.2897C11.6279 18.2119 11.6798 18.083 11.7835 17.8254L12.4993 16.25M8.33268 18.3334C5.15276 17.6836 2.60712 15.2757 1.74082 12.1615C1.66811 11.9001 1.63175 11.7694 1.70965 11.699C1.78755 11.6286 1.91637 11.6805 2.17398 11.7842L3.74935 12.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5M12.5 10C12.5 8.61925 11.3807 7.5 10 7.5M12.5 10H13.75M10 12.5C8.61925 12.5 7.5 11.3807 7.5 10M10 12.5V13.75M10 7.5C8.61925 7.5 7.5 8.61925 7.5 10M10 7.5V6.25M7.5 10H6.25M11.7677 8.23224L12.6517 7.34836M8.23223 11.7677L7.34835 12.6517M11.7677 11.7677L12.6517 12.6517M8.23223 8.23224L7.34835 7.34836"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const UserMultiple = withSvg(
  <>
    <path
      d="M15.5134 14.6665H15.9219C16.8801 14.6665 17.6423 14.2299 18.3266 13.6195C20.065 12.0687 15.9784 10.4998 14.5833 10.4998M12.9167 2.22381C13.1059 2.18628 13.3024 2.1665 13.504 2.1665C15.0206 2.1665 16.25 3.28579 16.25 4.6665C16.25 6.04722 15.0206 7.1665 13.504 7.1665C13.3024 7.1665 13.1059 7.14673 12.9167 7.1092"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.73443 11.4258C2.75195 11.9523 0.175948 13.0274 1.7449 14.3727C2.51133 15.0298 3.36492 15.4998 4.4381 15.4998H10.5619C11.6351 15.4998 12.4887 15.0298 13.2551 14.3727C14.8241 13.0274 12.2481 11.9523 11.2656 11.4258C8.96167 10.1912 6.03832 10.1912 3.73443 11.4258Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.8333 4.24984C10.8333 6.09079 9.34095 7.58317 7.5 7.58317C5.65905 7.58317 4.16667 6.09079 4.16667 4.24984C4.16667 2.40889 5.65905 0.916504 7.5 0.916504C9.34095 0.916504 10.8333 2.40889 10.8333 4.24984Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const LeftToRigthListDash = withSvg(
  <>
    <path d="M9 5H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 5H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 12H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 19H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 19H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </>
)

export const ArrowDown = withSvg(
  <path
    d="M10.25 5.24996C10.25 5.24996 6.9358 0.75001 5.74996 0.75C4.56413 0.74999 1.25 5.25 1.25 5.25"
    stroke="#101A23"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const ArrowMoveDown = withSvg(
  <>
    <path
      d="M1.58301 0.75V1.96154C1.58301 3.12875 1.58301 3.71236 1.66778 4.20068C2.13443 6.88872 4.44517 8.99691 7.39147 9.42266C7.9267 9.5 9.05365 9.5 10.333 9.5"
      stroke="#101A23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16602 11.25C9.52001 10.9059 10.916 9.99016 10.916 9.5C10.916 9.00984 9.52 8.09407 9.16602 7.75"
      stroke="#101A23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Building1 = withSvg(
  <>
    <path d="M13 7H9C6.518 7 6 7.518 6 10V21H16V10C16 7.518 15.482 7 13 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M10 11L12 11M10 14H12M10 17H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20 21V7.18564C20 5.95735 20 5.3432 19.7013 4.84966C19.4026 4.35612 18.8647 4.08147 17.7889 3.53216L13.4472 1.31536C12.2868 0.722844 12 0.931662 12 2.22873V6.7035"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 21V12C2 11.1727 2.17267 11 3 11H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 21H1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Passport = withSvg(
  <>
    <path
      d="M1.91699 10.5C1.91699 6.96447 1.91699 5.1967 3.13738 4.09835C4.35777 3 6.32196 3 10.2503 3C14.1787 3 16.1429 3 17.3632 4.09835C18.5837 5.1967 18.5837 6.96447 18.5837 10.5C18.5837 14.0355 18.5837 15.8033 17.3632 16.9017C16.1429 18 14.1787 18 10.2503 18C6.32196 18 4.35777 18 3.13738 16.9017C1.91699 15.8033 1.91699 14.0355 1.91699 10.5Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.41699 14.25C5.42392 12.0991 9.17716 11.9576 10.2503 14.25M9.00033 8.41667C9.00033 9.33717 8.25413 10.0833 7.33366 10.0833C6.41318 10.0833 5.66699 9.33717 5.66699 8.41667C5.66699 7.49619 6.41318 6.75 7.33366 6.75C8.25413 6.75 9.00033 7.49619 9.00033 8.41667Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path d="M12.75 8.83325H16.0833" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.75 12.1667H16.0833" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const MapLocation1 = withSvg(
  <>
    <path
      d="M13.1076 11.9557C12.9671 12.091 12.7792 12.1667 12.5837 12.1667C12.3882 12.1667 12.2004 12.091 12.0599 11.9557C10.773 10.7087 9.0483 9.31567 9.88938 7.29322C10.3441 6.19972 11.4357 5.5 12.5837 5.5C13.7317 5.5 14.8233 6.19972 15.278 7.29322C16.118 9.31308 14.3976 10.7129 13.1076 11.9557Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path d="M12.583 8.41675H12.5905" stroke="#2A3845" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.58301 10.4999C2.58301 6.76797 2.58301 4.90199 3.74237 3.74262C4.90175 2.58325 6.76772 2.58325 10.4997 2.58325C14.2316 2.58325 16.0976 2.58325 17.257 3.74262C18.4163 4.90199 18.4163 6.76797 18.4163 10.4999C18.4163 14.2318 18.4163 16.0978 17.257 17.2573C16.0976 18.4166 14.2316 18.4166 10.4997 18.4166C6.76772 18.4166 4.90175 18.4166 3.74237 17.2573C2.58301 16.0978 2.58301 14.2318 2.58301 10.4999Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path d="M14.6667 17.9999L3 6.33325" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.83301 12.1667L3.83301 17.1667" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const MapLocation2 = withSvg(
  <>
    <path
      d="M19.0837 8.83341V8.18132C19.0837 6.56497 19.0837 5.75681 18.5955 5.25466C18.1073 4.75253 17.3217 4.75253 15.7503 4.75253H14.0182C13.2537 4.75253 13.2473 4.75105 12.5599 4.40703L9.78358 3.0177C8.62436 2.43761 8.04476 2.14757 7.42731 2.16773C6.80985 2.18789 6.2493 2.51515 5.1282 3.16967L4.10498 3.76706C3.28148 4.24782 2.86973 4.48821 2.64336 4.88811C2.41699 5.28802 2.41699 5.77502 2.41699 6.74902V13.5965C2.41699 14.8762 2.41699 15.5162 2.70221 15.8723C2.892 16.1092 3.15796 16.2686 3.45199 16.3214C3.89388 16.4007 4.43489 16.0849 5.51688 15.4532C6.25163 15.0242 6.95875 14.5787 7.83772 14.6996C8.57423 14.8007 9.25866 15.2655 9.91699 15.5949"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.41699 2.16675V14.6667" stroke="#2A3845" strokeWidth="1.25" strokeLinejoin="round" />
    <path d="M13.25 4.66675V8.41675" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.0066 18.5696C15.8259 18.7388 15.5844 18.8333 15.3331 18.8333C15.0818 18.8333 14.8403 18.7388 14.6596 18.5696C13.0049 17.0108 10.7876 15.2696 11.8689 12.7415C12.4536 11.3747 13.8571 10.5 15.3331 10.5C16.8091 10.5 18.2126 11.3747 18.7973 12.7415C19.8773 15.2663 17.6653 17.0162 16.0066 18.5696Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path d="M15.333 14.25H15.3405" stroke="#2A3845" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const UserGroup = withSvg(
  <>
    <path
      d="M20.774 18C21.5233 18 22.1193 17.5285 22.6544 16.8691C23.7499 15.5194 21.9513 14.4408 21.2653 13.9126C20.568 13.3756 19.7894 13.0714 19 13M18 11C19.3807 11 20.5 9.88071 20.5 8.5C20.5 7.11929 19.3807 6 18 6"
      stroke="#1D5EA0"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.22596 18C2.47665 18 1.88067 17.5285 1.34554 16.8691C0.250091 15.5194 2.04867 14.4408 2.73464 13.9126C3.43197 13.3756 4.21058 13.0714 5 13M5.5 11C4.11929 11 3 9.88071 3 8.5C3 7.11929 4.11929 6 5.5 6"
      stroke="#1D5EA0"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.0838 15.1112C7.06202 15.743 4.38298 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81562 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4798 13.6296 8.0838 15.1112Z"
      stroke="#1D5EA0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z"
      stroke="#1D5EA0"
      strokeWidth="1.5"
    />
  </>
)

export const BriefCase01 = withSvg(
  <>
    <path
      d="M10.484 13.3333C10.484 13.0233 10.484 12.8683 10.5163 12.7412C10.6038 12.3961 10.8592 12.1265 11.1862 12.0341C11.3066 12 11.4534 12 11.7471 12H13.0103C13.304 12 13.4509 12 13.5712 12.0341C13.8981 12.1265 14.1536 12.3961 14.2411 12.7412C14.2734 12.8683 14.2734 13.0233 14.2734 13.3333V14C14.2734 15.1045 13.4252 16 12.3787 16C11.3322 16 10.484 15.1045 10.484 14V13.3333Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1787 13.5H15.2991C16.5157 13.5 17.124 13.5 17.6419 13.3843C19.141 13.049 20.3641 12.0207 20.8992 10.6455C21.0841 10.1704 21.1595 9.59552 21.3105 8.44569C21.3672 8.01405 21.3955 7.79823 21.3683 7.62169C21.2889 7.10753 20.8986 6.68637 20.3727 6.54764C20.1921 6.5 19.9638 6.5 19.5071 6.5H5.25034C4.7936 6.5 4.56523 6.5 4.38467 6.54764C3.85885 6.68637 3.46848 7.10753 3.38915 7.62169C3.36192 7.79823 3.39024 8.01405 3.44689 8.44569C3.5978 9.59552 3.67325 10.1704 3.85815 10.6455C4.39333 12.0207 5.61637 13.049 7.11546 13.3843C7.63338 13.5 8.24171 13.5 9.45836 13.5H10.5787"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M4.32606 11.5V13.5C4.32606 17.2712 4.32606 19.1569 5.37432 20.3284C6.42256 21.5 8.1097 21.5 11.484 21.5H13.2734C16.6478 21.5 18.3349 21.5 19.383 20.3284C20.4313 19.1569 20.4313 17.2712 20.4313 13.5V11.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6945 6.5L15.6212 6.14679C15.2565 4.38673 15.0741 3.50671 14.64 3.00335C14.2059 2.5 13.6291 2.5 12.4756 2.5H12.2818C11.1283 2.5 10.5516 2.5 10.1174 3.00335C9.68323 3.50671 9.50085 4.38673 9.13612 6.14679L9.06291 6.5"
      stroke="currentColor"
      strokeWidth="1.125"
    />
  </>
)

export const MapPin = withSvg(
  <>
    <path
      d="M7 9.00195C4.82497 9.01507 3.64706 9.11956 2.87868 9.95197C2 10.9039 2 12.4359 2 15.5C2 18.5642 2 20.0962 2.87868 21.0481C3.75736 22 5.17157 22 8 22H16C18.8284 22 20.2426 22 21.1213 21.0481C22 20.0962 22 18.5642 22 15.5C22 12.4359 22 10.9039 21.1213 9.95197C20.3529 9.11956 19.175 9.01507 17 9.00195"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12L10.5 14.625M10.5 14.625L13.8 16.55M10.5 14.625L6 17.6M18 19L13.8 16.55M13.8 16.55L18 13.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7C13.3807 7 14.5 5.88071 14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5C9.5 5.88071 10.6193 7 12 7ZM12 7V11"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </>
)

export const Maping = withSvg(
  <>
    <path
      d="M5.48209 4.19584L4.31885 4.90813C3.38266 5.48137 2.91457 5.768 2.65722 6.24483C2.39987 6.72165 2.39987 7.30233 2.39987 8.46368V16.6283C2.39987 18.1543 2.39987 18.9172 2.72413 19.3419C2.93989 19.6244 3.24224 19.8143 3.57651 19.8773C4.07886 19.9719 4.69391 19.5953 5.92396 18.8421C6.75925 18.3307 7.56315 17.7995 8.56239 17.9435C9.01693 18.0091 9.45049 18.2367 10.3176 18.6917L13.9307 20.588C14.7123 20.9983 14.7195 21 15.5886 21H17.5578C19.3441 21 20.2373 21 20.7923 20.4013C21.3472 19.8027 21.3472 18.8389 21.3472 16.9117V10.1715C21.3472 8.24423 21.3472 7.2806 20.7923 6.68188C20.2373 6.08316 19.3441 6.08316 17.5578 6.08316H15.5886C14.7195 6.08316 14.7123 6.08139 13.9307 5.6712L10.7745 4.01463C9.45667 3.32297 8.79776 2.97715 8.09582 3.00117C7.39386 3.02521 6.75661 3.41543 5.48209 4.19584Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.7157 6.5V20.5" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0.75 2.25" />
    <path d="M8.08408 3.5V17.5" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0.75 2.25" />
  </>
)

export const BatteriesEnergy = withSvg(
  <>
    <path d="M12.095 2L9.72657 6H13.516L11.1476 10" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.3581 6C17.2513 6 17.6979 6 17.9754 6.29289C18.2529 6.58579 18.2529 7.05719 18.2529 8V10.5M6.88446 6C5.99127 6 5.54468 6 5.26719 6.29289C4.98973 6.58579 4.98973 7.05719 4.98973 8V10.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2003 13H17.3055C16.4123 13 15.9657 13 15.6883 13.2929C15.4108 13.5859 15.4108 14.0572 15.4108 15V20C15.4108 20.9428 15.4108 21.4141 15.6883 21.7071C15.9657 22 16.4123 22 17.3055 22H19.2003C20.0934 22 20.54 22 20.8175 21.7071C21.095 21.4141 21.095 20.9428 21.095 20V15C21.095 14.0572 21.095 13.5859 20.8175 13.2929C20.54 13 20.0934 13 19.2003 13Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15.4108 19H21.095" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.4108 16H21.095" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.93709 13H4.04236C3.14917 13 2.70258 13 2.42509 13.2929C2.14762 13.5859 2.14762 14.0572 2.14762 15V20C2.14762 20.9428 2.14762 21.4141 2.42509 21.7071C2.70258 22 3.14917 22 4.04236 22H5.93709C6.83027 22 7.27686 22 7.55435 21.7071C7.83183 21.4141 7.83183 20.9428 7.83183 20V15C7.83183 14.0572 7.83183 13.5859 7.55435 13.2929C7.27686 13 6.83027 13 5.93709 13Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.14762 19H7.83183" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.14762 16H7.83183" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Search = withSvg(
  <>
    <path d="M17.5 17.5L22 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20 11C20 6.02944 15.9705 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9705 6.02944 20 11 20C15.9705 20 20 15.9705 20 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </>
)

export const Add01 = withSvg(
  <>
    <path d="M12 1.71428V22.2857" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.71429 12H22.2857" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const ArrowUp = withSvg(
  <path
    d="M23.6803 16.7691L12.7718 5.65917C12.6705 5.55588 12.5502 5.47393 12.4177 5.41801C12.2853 5.36211 12.1434 5.33333 12 5.33333C11.8566 5.33333 11.7147 5.36211 11.5823 5.41801C11.4498 5.47393 11.3295 5.55588 11.2282 5.65917L0.319681 16.7691C0.114993 16.9775 0 17.2603 0 17.5551C0 17.8499 0.114993 18.1327 0.319681 18.3411C0.524369 18.5496 0.801987 18.6667 1.09146 18.6667C1.38093 18.6667 1.65855 18.5496 1.86324 18.3411L12 8.01585L22.1368 18.3411C22.2381 18.4443 22.3584 18.5261 22.4908 18.582C22.6233 18.6379 22.7652 18.6667 22.9085 18.6667C23.0519 18.6667 23.1937 18.6379 23.3263 18.582C23.4587 18.5261 23.5789 18.4443 23.6803 18.3411C23.7817 18.2379 23.862 18.1153 23.9169 17.9804C23.9717 17.8456 24 17.7011 24 17.5551C24 17.4091 23.9717 17.2645 23.9169 17.1297C23.862 16.9948 23.7817 16.8723 23.6803 16.7691Z"
    fill="currentColor"
  />
)

export const ChartBubble = withSvg(
  <>
    <path
      d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="11.5" cy="15.5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="17.5" cy="7.5" r="3.5" stroke="currentColor" strokeWidth="1.5" />
  </>
)

export const FileDownload = withSvg(
  <>
    <path
      d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9V2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13V14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Download4 = withSvg(
  <>
    <path
      d="M12 14.5L12 4.5M12 14.5C11.2998 14.5 9.99153 12.5057 9.5 12M12 14.5C12.7002 14.5 14.0085 12.5057 14.5 12"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Passport2 = withSvg(
  <>
    <path
      d="M12.9503 22C15.595 22 16.9173 22 17.8667 21.2437C18.8161 20.4874 19.1189 19.1927 19.7247 16.6033L21.642 8.40696C21.9773 6.97362 22.1449 6.25695 21.8405 5.7379C21.2878 4.79528 19.8789 5 18.9593 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 9C2 5.70017 2 4.05025 3.02513 3.02513C4.05025 2 5.70017 2 9 2H12C15.2998 2 16.9497 2 17.9749 3.02513C19 4.05025 19 5.70017 19 9V15C19 18.2998 19 19.9497 17.9749 20.9749C16.9497 22 15.2998 22 12 22H9C5.70017 22 4.05025 22 3.02513 20.9749C2 19.9497 2 18.2998 2 15V9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.5 6C12.7091 6 14.5 7.79086 14.5 10C14.5 12.2091 12.7091 14 10.5 14M10.5 6C8.29086 6 6.5 7.79086 6.5 10C6.5 12.2091 8.29086 14 10.5 14M10.5 6C9.67157 6 9 7.79086 9 10C9 12.2091 9.67157 14 10.5 14M10.5 6C11.3284 6 12 7.79086 12 10C12 12.2091 11.3284 14 10.5 14"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M7 17L14 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </>
)

export const ArrowReloadHorizontal = withSvg(
  <>
    <path
      d="M20.209 5.80915H9.73289C6.19643 5.80915 3.54241 8.36632 3.54241 11.9997"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.01785 18.1905H14.4941C18.0305 18.1905 20.6846 15.6334 20.6846 12"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3035 3.42857C18.3035 3.42857 20.6846 5.18211 20.6846 5.80954C20.6846 6.43697 18.3035 8.19048 18.3035 8.19048"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.92335 15.8091C5.92335 15.8091 3.54242 17.5626 3.54241 18.1901C3.5424 18.8175 5.92336 20.5711 5.92336 20.5711"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Chatting = withSvg(
  <>
    <path
      d="M20 9C19.2048 5.01455 15.5128 2 11.0793 2C6.06549 2 2 5.85521 2 10.61C2 12.8946 2.93819 14.9704 4.46855 16.5108C4.80549 16.85 5.03045 17.3134 4.93966 17.7903C4.78982 18.5701 4.45026 19.2975 3.95305 19.9037C5.26123 20.1449 6.62147 19.9277 7.78801 19.3127C8.20039 19.0954 8.40657 18.9867 8.55207 18.9646C8.65392 18.9492 8.78659 18.9636 9 19.0002"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 16.2617C11 19.1674 13.4628 21.5234 16.5 21.5234C16.8571 21.5238 17.2132 21.4908 17.564 21.425C17.8165 21.3775 17.9428 21.3538 18.0309 21.3673C18.119 21.3807 18.244 21.4472 18.4938 21.58C19.2004 21.9558 20.0244 22.0885 20.8169 21.9411C20.5157 21.5707 20.31 21.1262 20.2192 20.6496C20.1642 20.3582 20.3005 20.075 20.5046 19.8677C21.4317 18.9263 22 17.6578 22 16.2617C22 13.356 19.5372 11 16.5 11C13.4628 11 11 13.356 11 16.2617Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </>
)

export const UserRemove = withSvg(
  <>
    <path
      d="M13 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453366 18.0441 4.1628 16.324 5.57757 15.4816C7.97679 14.053 10.8425 13.6575 13.5 14.2952"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path d="M16 22L19 19M19 19L22 16M19 19L16 16M19 19L22 22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
  </>
)

export const Call02 = withSvg(
  <path
    d="M9.57929 6.01165L9.19581 5.14881C8.94506 4.58465 8.81969 4.30255 8.63219 4.08667C8.39721 3.81614 8.09093 3.61709 7.74826 3.51224C7.47485 3.42857 7.16615 3.42857 6.54877 3.42857C5.64562 3.42857 5.19406 3.42857 4.81498 3.60218C4.36845 3.80669 3.96518 4.25074 3.8045 4.71486C3.6681 5.10885 3.70718 5.51375 3.78531 6.32352C4.61705 14.9431 9.34269 19.6687 17.9622 20.5003C18.772 20.5785 19.1769 20.6176 19.5709 20.4813C20.035 20.3206 20.479 19.9173 20.6835 19.4707C20.8571 19.0917 20.8571 18.6401 20.8571 17.7369C20.8571 17.1195 20.8571 16.8109 20.7735 16.5374C20.6686 16.1947 20.4696 15.8885 20.199 15.6535C19.9832 15.4659 19.7011 15.3407 19.1369 15.0899L18.2741 14.7064C17.6631 14.4349 17.3576 14.2991 17.0472 14.2696C16.7501 14.2414 16.4505 14.2831 16.1725 14.3913C15.8818 14.5045 15.6251 14.7185 15.1114 15.1465C14.6001 15.5726 14.3446 15.7856 14.0321 15.8997C13.7552 16.0008 13.3891 16.0384 13.0975 15.9953C12.7685 15.9469 12.5166 15.8123 12.0126 15.543C10.445 14.7053 9.5805 13.8408 8.74273 12.273C8.47346 11.7693 8.33883 11.5173 8.29035 11.1883C8.24737 10.8966 8.28483 10.5305 8.386 10.2536C8.50011 9.94122 8.71315 9.68558 9.13922 9.17429C9.56726 8.66065 9.78127 8.40383 9.89442 8.11325C10.0027 7.83518 10.0444 7.53562 10.0161 7.23855C9.98661 6.92811 9.85083 6.62263 9.57929 6.01165Z"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
  />
)

export const GoogleDoc = withSvg(
  <>
    <path
      d="M15 2.95201V4.38058C15 5.72745 15 6.40088 15.4393 6.8193C15.8786 7.23773 16.5858 7.23773 18 7.23773H19.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.9999 15.8099V8.19085C3.9999 5.49711 3.9999 4.15024 4.87859 3.31341C5.75726 2.47656 7.17148 2.47656 9.9999 2.47656H14.1715C14.5802 2.47656 14.7846 2.47656 14.9684 2.54906C15.1522 2.62155 15.2968 2.75919 15.5857 3.03446L19.4141 6.68057C19.7032 6.95584 19.8478 7.09347 19.9238 7.26849C19.9999 7.44352 19.9999 7.63816 19.9999 8.02745V15.8099C19.9999 18.5037 19.9999 19.8505 19.1212 20.6873C18.2425 21.5242 16.8283 21.5242 13.9999 21.5242H9.9999C7.17148 21.5242 5.75726 21.5242 4.87859 20.6873C3.9999 19.8505 3.9999 18.5037 3.9999 15.8099Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0001 11.048H16.0001M8.0001 13.9051H16.0001M8.0001 16.7623H12.1709"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Building05 = withSvg(
  <>
    <path d="M2.19057 21.5234H21.2382" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" />
    <path
      d="M17.4287 9.14286H13.6191C11.2553 9.14286 10.762 9.63619 10.762 12V21.5238H20.2858V12C20.2858 9.63619 19.7925 9.14286 17.4287 9.14286Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M14.5714 21.5242H3.14286V5.3337C3.14286 2.9699 3.63619 2.47656 6 2.47656H11.7143C14.0781 2.47656 14.5714 2.9699 14.5714 5.3337V9.14323"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path d="M3.14286 6.28571H6M3.14286 10.0952H6M3.14286 13.9048H6" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M14.5714 12.952H16.4762M14.5714 15.8091H16.4762" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5238 21.5234V18.6663" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Mail01 = withSvg(
  <>
    <path
      d="M2.762 6.28571L9.34583 10.0162C11.773 11.3914 12.7985 11.3914 15.2258 10.0162L21.8096 6.28571"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M2.77702 13.4057C2.83927 16.3254 2.87041 17.785 3.94767 18.8665C5.02493 19.9478 6.52422 19.9854 9.52279 20.0608C11.3709 20.1072 13.2008 20.1072 15.0488 20.0608C18.0474 19.9854 19.5466 19.9478 20.624 18.8665C21.7013 17.785 21.7323 16.3254 21.7945 13.4057C21.8146 12.467 21.8146 11.5338 21.7945 10.595C21.7323 7.67547 21.7013 6.21569 20.624 5.13433C19.5466 4.05297 18.0474 4.0153 15.0488 3.93997C13.2008 3.89352 11.3709 3.89352 9.52278 3.93995C6.52422 4.01529 5.02493 4.05295 3.94767 5.13432C2.8704 6.21569 2.83927 7.67546 2.77701 10.595C2.75698 11.5338 2.75699 12.467 2.77702 13.4057Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </>
)

export const MailSend02 = withSvg(
  <>
    <path
      d="M22 12.5001C22 12.0087 21.9947 11.0172 21.9841 10.5244C21.9189 7.45887 21.8863 5.92609 20.7551 4.79067C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09881 3.53656C5.95033 3.61567 4.37608 3.65521 3.24495 4.79065C2.11383 5.92608 2.08113 7.45885 2.01576 10.5244C1.99473 11.5101 1.99475 12.4899 2.01577 13.4756C2.08115 16.5412 2.11383 18.0739 3.24496 19.2095C4.37608 20.3448 5.95033 20.3843 9.09883 20.4635C9.90159 20.4836 10.7011 20.4955 11.5 20.4989"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.5L9.94203 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 17.5H14M22 17.5C22 16.7997 20.0057 15.4915 19.5 15M22 17.5C22 18.2003 20.0057 19.5085 19.5 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Group = withSvg(
  <>
    <path d="M17.8002 5.1994L19.0013 6.34226L21.0002 4.4375" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20.582 9.29713C20.855 10.1123 20.996 10.9624 21 11.8181C21 16.552 16.9705 20.3895 12 20.3895C7.02943 20.3895 3 16.552 3 11.8181C3 7.08421 7.02943 3.24665 12 3.24665C12.8984 3.25046 13.791 3.3847 14.647 3.64474"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6803 7.26435C11.8041 7.09199 12.0313 7.01653 12.2407 7.07822C12.4501 7.13991 12.593 7.32436 12.5929 7.53316V10.6231H15.4993C15.6848 10.6231 15.855 10.7209 15.9415 10.8771C16.0282 11.0333 16.0168 11.2223 15.912 11.3681L12.3199 16.3715C12.1962 16.5439 11.969 16.6194 11.7596 16.5577C11.5501 16.496 11.4073 16.3115 11.4074 16.1027V13.0128H8.50094C8.31548 13.0128 8.14528 12.9151 8.05874 12.7589C7.97221 12.6026 7.98358 12.4136 8.08828 12.2678L11.6803 7.26435Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const CheckMarkSquare03 = withSvg(
  <>
    <path
      d="M21.4477 8.2C21.5 9.25014 21.5 10.4994 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C13.0719 2.5 14.0156 2.5 14.85 2.51908"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11.5C8 11.5 9.5 11.5 11.5 15C11.5 15 16.5588 5.83333 21.5 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const CancelSquare = withSvg(
  <>
    <path d="M15 9L9 14.9996M15 15L9 9.00039" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>
)

export const File02 = withSvg(
  <>
    <path d="M8 17H16" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 13H12" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13 2.5V3C13 5.82843 13 7.24264 13.8787 8.12132C14.7574 9 16.1716 9 19 9H19.5M20 10.6569V14C20 17.7712 20 19.6569 18.8284 20.8284C17.6569 22 15.7712 22 12 22C8.22876 22 6.34315 22 5.17157 20.8284C4 19.6569 4 17.7712 4 14V9.45584C4 6.21082 4 4.58831 4.88607 3.48933C5.06508 3.26731 5.26731 3.06508 5.48933 2.88607C6.58831 2 8.21082 2 11.4558 2C12.1614 2 12.5141 2 12.8372 2.11401C12.9044 2.13772 12.9702 2.165 13.0345 2.19575C13.3436 2.34355 13.593 2.593 14.0919 3.09188L18.8284 7.82843C19.4065 8.40649 19.6955 8.69552 19.8478 9.06306C20 9.4306 20 9.83935 20 10.6569Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Tick01 = withSvg(
  <path
    d="M5 14.5C5 14.5 6.5 14.5 8.5 18C8.5 18 14.0588 8.83333 19 7"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const Factory02 = withSvg(
  <path
    d="M10.154 21H21C21.471 21 21.707 21 21.854 20.854C22 20.707 22 20.47 22 20V7L17.64 10.633C16.93 11.225 16.576 11.52 16.288 11.385C16 11.25 16 10.79 16 9.865V7L11.552 10.235C11.03 10.615 10.77 10.804 10.468 10.902C10.167 11 9.84401 11 9.20001 11H9.00001M4.00001 6H8.00001M12 15H14M17 15H19M2.05701 19.874L4.00501 4.701C4.18301 3.314 4.53501 3 5.95601 3C7.37701 3 7.73001 3.314 7.90801 4.7L10 21H3.06001C2.52501 21 2.25801 21 2.10701 20.83C1.95601 20.661 1.99001 20.399 2.05701 19.874Z"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const DocumentAttachment = withSvg(
  <>
    <path
      d="M21 11V10C21 6.22876 21 4.34315 19.7595 3.17157C18.519 2 16.5225 2 12.5294 2L11.4706 2C7.47752 2 5.48098 2 4.24049 3.17157C3 4.34315 3 6.22876 3 10L3 14C3 17.7712 3 19.6569 4.24049 20.8284C5.48098 22 7.47751 22 11.4706 22H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M8 7L16 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8 12L13 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M21 20.6471L21 17C21 15.5706 19.6569 14 18 14C16.3431 14 15 15.5706 15 17L15 20.5C15 21.2797 15.7326 22 16.6364 22C17.5401 22 18.2727 21.2797 18.2727 20.5L18.2727 17.7647"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>
)

export const Attachment2 = withSvg(
  <path
    d="M8 8.00049V6.00049C8 3.79135 9.79086 2.00049 12 2.00049C14.2091 2.00049 16 3.79135 16 6.00049V18.0005C16 20.2096 14.2091 22.0005 12 22.0005C9.79086 22.0005 8 20.2096 8 18.0005V13.5005C8 12.1198 9.11929 11.0005 10.5 11.0005C11.8807 11.0005 13 12.1198 13 13.5005V16.0005"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export const CheckmarkCircle03 = withSvg(
  <>
    <g clipPath="ur#clip0_1_2)">
      <path
        d="M16.898 3.33782C15.4571 2.48697 13.7843 2 12 2C6.58986 2 2.20408 6.47715 2.20408 12C2.20408 17.5229 6.58986 22 12 22C17.4101 22 21.7959 17.5229 21.7959 12C21.7959 11.3151 21.7285 10.6462 21.6 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.08163 12.5C8.08163 12.5 9.55102 12.5 11.5102 16C11.5102 16 16.9556 6.83335 21.7959 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
)

export const DocumentValidation = withSvg(
  <>
    <path
      d="M14.9805 7.01562C14.9805 7.01562 15.4805 7.51562 15.9805 8.51562C15.9805 8.51562 17.5687 6.01562 18.9805 5.51562"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99485 2.0214C7.49638 1.91562 5.56612 2.20344 5.56612 2.20344C4.34727 2.29059 2.01146 2.97391 2.01148 6.9646C2.0115 10.9214 1.98564 15.7994 2.01148 17.744C2.01148 18.9321 2.7471 21.7034 5.29326 21.8519C8.3881 22.0325 13.9627 22.0709 16.5204 21.8519C17.2051 21.8133 19.4846 21.2758 19.7731 18.7957C20.072 16.2264 20.0125 14.4408 20.0125 14.0158"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9998 7.01562C21.9998 9.77705 19.7591 12.0157 16.995 12.0157C14.2309 12.0157 11.9902 9.77705 11.9902 7.01562C11.9902 4.2542 14.2309 2.01562 16.995 2.01562C19.7591 2.01562 21.9998 4.2542 21.9998 7.01562Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path d="M6.98047 13.0156H10.9804" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M6.98047 17.0156H14.9804" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
  </>
)

export const Upload04 = withSvg(
  <>
    <path
      d="M12 4.5L12 14.5M12 4.5C11.2998 4.5 9.99153 6.4943 9.5 7M12 4.5C12.7002 4.5 14.0085 6.4943 14.5 7"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Comment01 = withSvg(
  <>
    <path d="M8 13.5H16M8 8.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>
)

// Checkbox Icons
export const UncheckedIcon = withSvg(
  <>
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#D0D5DD" />
  </>
)
export const MinusIcon = withSvg(
  <>
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#237AD2" fillOpacity="0.08" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#237AD2" />
    <path d="M5.9165 10H14.0832" stroke="#237AD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </>
)
export const CheckedIcon = withSvg(
  <>
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#237AD2" fillOpacity="0.08" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#237AD2" />
    <path d="M14.6668 6.5L8.25016 12.9167L5.3335 10" stroke="#237AD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const Analyst = withSvg(
  <>
    <g clipPath="url(#clip0_5521_73209)">
      <path
        d="M1.22 40H38C38.1676 40.0006 38.3293 39.938 38.4529 39.8247C38.5764 39.7114 38.6528 39.5557 38.6667 39.3887L39.9407 24.11C39.9559 23.926 39.9328 23.7408 39.8727 23.5662C39.8126 23.3916 39.7169 23.2314 39.5917 23.0957C39.4665 22.9601 39.3145 22.8519 39.1452 22.778C38.976 22.7041 38.7933 22.6662 38.6087 22.6667H25.9467C25.6128 22.6685 25.2917 22.7949 25.0461 23.021C24.8005 23.2471 24.648 23.5568 24.6187 23.8893L24.4913 25.4167C23.0626 24.078 21.1779 23.3331 19.22 23.3333H19.034C18.5988 22.7785 18.006 22.3683 17.3333 22.1567V21.4413C18.2729 20.8101 19.056 19.9729 19.6231 18.9933C20.1903 18.0138 20.5264 16.9177 20.606 15.7887C20.9292 15.6834 21.2277 15.5135 21.4833 15.2895C21.739 15.0655 21.9465 14.7919 22.0933 14.4853C22.5745 13.4115 22.7719 12.232 22.6667 11.06V9.51267C22.6875 7.01442 21.7165 4.60991 19.9668 2.82659C18.2171 1.04327 15.8315 0.0267469 13.3333 0C10.8351 0.0267469 8.44955 1.04327 6.69985 2.82659C4.95014 4.60991 3.9792 7.01442 4 9.51267V11.06C3.89458 12.2336 4.09294 13.4146 4.576 14.4893C4.72235 14.7953 4.92946 15.0683 5.1847 15.2917C5.43994 15.5151 5.73798 15.6842 6.06067 15.7887C6.14044 16.9177 6.47667 18.0137 7.04378 18.9932C7.61088 19.9727 8.39393 20.81 9.33333 21.4413V22.1567C8.6607 22.3683 8.06783 22.7785 7.63267 23.3333H7.44667C3.34067 23.3333 0 26.5067 0 30.4067V38.78C0.000352925 39.1035 0.129002 39.4136 0.35772 39.6423C0.586437 39.871 0.896544 39.9996 1.22 40ZM13.3333 25.5693C13.9085 25.6432 14.4629 25.8323 14.9633 26.1253L14.2153 28H12.4513L11.704 26.1333C12.2044 25.8394 12.7583 25.6477 13.3333 25.5693ZM12.6147 29.3333H14.052L14.8127 38.6667H11.854L12.6147 29.3333ZM15.344 28.7693L15.944 27.2673C15.9733 27.3417 15.9984 27.4176 16.0193 27.4947C16.0442 27.5943 16.0917 27.6869 16.1582 27.7652C16.2247 27.8434 16.3084 27.9053 16.4027 27.9459C16.4971 27.9865 16.5995 28.0047 16.7021 27.9992C16.8047 27.9937 16.9046 27.9645 16.994 27.914C17.3432 27.7023 17.6652 27.4486 17.9527 27.1587C17.7913 31.178 17.2353 35.8093 16.0813 37.8253L15.344 28.7693ZM10.2667 27.946C10.361 27.9054 10.4447 27.8435 10.5112 27.7652C10.5777 27.6869 10.6252 27.5943 10.65 27.4947C10.6709 27.4176 10.696 27.3417 10.7253 27.2673L11.3253 28.7693L10.5727 37.9753C9.458 36.17 8.87133 31.468 8.71 27.1547C8.99817 27.4464 9.32129 27.7015 9.672 27.914C9.76144 27.9645 9.86134 27.9937 9.96392 27.9993C10.0665 28.0048 10.169 27.9866 10.2633 27.946H10.2667ZM23.3867 38.6667H20.6667V36.6667H23.5533L23.3867 38.6667ZM38.6093 24L37.3867 38.6667H24.7247L25.9467 24H38.6093ZM24.3367 27.27L23.6667 35.3333H20.6667C20.313 35.3333 19.9739 35.4738 19.7239 35.7239C19.4738 35.9739 19.3333 36.313 19.3333 36.6667V38.6667H17.1087C18.01 37.2247 18.6353 34.73 19.004 31.1147C19.276 28.4427 19.326 25.8613 19.3333 24.6733C20.3124 24.684 21.2753 24.9245 22.1444 25.3756C23.0134 25.8266 23.7644 26.4755 24.3367 27.27ZM17.9953 24.168C17.9302 24.9781 17.5577 25.7325 16.954 26.2767C16.5886 25.6672 16.0584 25.1734 15.4247 24.852C16.0509 24.5152 16.589 24.0355 16.9953 23.452C17.3945 23.5818 17.7438 23.8319 17.9953 24.168ZM13.3333 1.33333C15.4384 1.35925 17.4504 2.20477 18.942 3.69032C20.4337 5.17588 21.2875 7.18441 21.322 9.28933C21.0639 9.22357 20.7936 9.22174 20.5347 9.284C19.9667 6.97267 17.6947 5.78867 16.2827 5.43533C16.0518 5.37287 15.8103 5.36012 15.5741 5.39793C15.338 5.43574 15.1125 5.52325 14.9127 5.65467C13.03 6.932 9.43467 7.53467 7.60733 7.614C7.18245 7.63697 6.78163 7.81845 6.48404 8.12258C6.18645 8.42671 6.01373 8.83138 6 9.25667C5.78156 9.22106 5.55817 9.23014 5.34333 9.28333C5.37943 7.17923 6.23405 5.17202 7.72583 3.68771C9.2176 2.20341 11.2291 1.35887 13.3333 1.33333ZM7.38533 15.6213C7.37232 15.3734 7.28275 15.1357 7.12896 14.9408C6.97518 14.746 6.76475 14.6036 6.52667 14.5333C6.36205 14.4897 6.2091 14.4103 6.07875 14.3007C5.94841 14.1911 5.84389 14.054 5.77267 13.8993C5.38357 13.0067 5.23221 12.0285 5.33333 11.06C5.33224 10.9798 5.34973 10.9005 5.38443 10.8282C5.41913 10.7559 5.47009 10.6926 5.53333 10.6433C5.59207 10.5967 5.66438 10.5705 5.73933 10.5687C5.7675 10.5686 5.79553 10.5724 5.82267 10.58C5.90707 10.6187 5.97409 10.6873 6.01067 10.7727C6.04 10.9355 6.12886 11.0817 6.25997 11.1827C6.39109 11.2836 6.55507 11.3323 6.72003 11.319C6.885 11.3058 7.03915 11.2317 7.1525 11.1111C7.26586 10.9906 7.33031 10.8321 7.33333 10.6667V9.32667C7.33017 9.23275 7.36285 9.14115 7.42476 9.07045C7.48667 8.99975 7.57315 8.95526 7.66667 8.946C9.71533 8.85667 13.5333 8.20067 15.654 6.762C15.6981 6.73607 15.7472 6.71955 15.798 6.71347C15.8488 6.70739 15.9003 6.71188 15.9493 6.72667C16.0893 6.76133 19.3333 7.60467 19.3333 10.4V10.6667C19.3336 10.8341 19.3969 10.9952 19.5105 11.1182C19.6242 11.2411 19.7799 11.3167 19.9468 11.3301C20.1137 11.3434 20.2795 11.2935 20.4113 11.1902C20.543 11.087 20.6311 10.9379 20.658 10.7727C20.6941 10.6876 20.7607 10.6191 20.8447 10.5807C20.8946 10.5672 20.947 10.5659 20.9976 10.5768C21.0482 10.5877 21.0954 10.6105 21.1353 10.6433C21.1986 10.6926 21.2495 10.7559 21.2842 10.8282C21.3189 10.9005 21.3364 10.9798 21.3353 11.06C21.437 12.0277 21.2863 13.0052 20.898 13.8973C20.8256 14.055 20.7189 14.1946 20.5857 14.3057C20.4525 14.4169 20.2961 14.497 20.128 14.54C19.8933 14.6114 19.6863 14.7534 19.5352 14.9467C19.3841 15.1399 19.2961 15.375 19.2833 15.62C19.2042 17.1505 18.5449 18.5932 17.4395 19.6547C16.3341 20.7161 14.8657 21.3164 13.3333 21.3333C11.8015 21.3159 10.3338 20.7156 9.2289 19.6545C8.12396 18.5934 7.46474 17.1512 7.38533 15.6213ZM13.3333 22.6667C14.2471 22.6668 15.1524 22.4914 16 22.15V22.526C15.8487 22.8227 15.2167 23.798 13.3333 24.2147C11.442 23.7967 10.812 22.8147 10.6667 22.528V22.15C11.5143 22.4914 12.4196 22.6668 13.3333 22.6667ZM9.67133 23.4493C10.0777 24.0329 10.6158 24.5125 11.242 24.8493C10.6085 25.1708 10.0785 25.6644 9.71267 26.2733C9.10878 25.7297 8.73613 24.9753 8.67133 24.1653C8.92298 23.8294 9.27222 23.5793 9.67133 23.4493ZM1.33333 30.4067C1.38551 28.8564 2.04273 27.3882 3.16422 26.3165C4.28571 25.2449 5.78227 24.655 7.33333 24.6733C7.34 25.892 7.38867 28.5807 7.66267 31.3207C8.016 34.854 8.61267 37.28 9.46867 38.668H1.33333V30.4067Z"
        fill="#2A3845"
      />
      <path
        d="M31.6474 32.6666C32.3648 32.649 33.0545 32.3863 33.6019 31.9222C34.1492 31.4582 34.5212 30.8208 34.6561 30.116C34.7231 29.7718 34.7139 29.4171 34.6292 29.0769C34.5444 28.7366 34.3861 28.4191 34.1654 28.1466C33.9425 27.8851 33.6642 27.6764 33.3507 27.5357C33.0372 27.395 32.6963 27.3259 32.3527 27.3333C31.6354 27.351 30.9457 27.6137 30.3983 28.0777C29.8509 28.5417 29.4789 29.1792 29.3441 29.884C29.277 30.2281 29.2862 30.5828 29.371 30.9231C29.4558 31.2633 29.6141 31.5808 29.8347 31.8533C30.0576 32.1149 30.3359 32.3235 30.6494 32.4642C30.963 32.6049 31.3039 32.674 31.6474 32.6666ZM30.6561 30.116C30.7388 29.7208 30.9501 29.3641 31.2572 29.1019C31.5642 28.8396 31.9495 28.6865 32.3527 28.6666C32.5013 28.661 32.6493 28.6882 32.7861 28.7464C32.9229 28.8046 33.0451 28.8923 33.1441 29.0033C33.2398 29.1265 33.3073 29.2693 33.3419 29.4214C33.3764 29.5736 33.3772 29.7315 33.3441 29.884C33.2614 30.2792 33.05 30.6358 32.743 30.8981C32.436 31.1603 32.0507 31.3134 31.6474 31.3333C31.4988 31.339 31.3509 31.3117 31.2141 31.2535C31.0773 31.1953 30.955 31.1076 30.8561 30.9966C30.7604 30.8734 30.6928 30.7307 30.6583 30.5785C30.6237 30.4263 30.623 30.2685 30.6561 30.116Z"
        fill="#2A3845"
      />
      <path
        d="M38.6667 0H25.3333C24.9797 0 24.6406 0.140476 24.3905 0.390524C24.1405 0.640573 24 0.979711 24 1.33333V13.3333C24 13.687 24.1405 14.0261 24.3905 14.2761C24.6406 14.5262 24.9797 14.6667 25.3333 14.6667H27.838L30.5853 17.4087C30.7698 17.5961 30.9897 17.7449 31.2322 17.8465C31.4747 17.9481 31.7351 18.0005 31.998 18.0005C32.261 18.0005 32.5213 17.9481 32.7638 17.8465C33.0063 17.7449 33.2262 17.5961 33.4107 17.4087L36.162 14.6667H38.6667C39.0203 14.6667 39.3594 14.5262 39.6095 14.2761C39.8595 14.0261 40 13.687 40 13.3333V1.33333C40 0.979711 39.8595 0.640573 39.6095 0.390524C39.3594 0.140476 39.0203 0 38.6667 0ZM38.6667 13.3333H35.8867C35.7102 13.3334 35.5409 13.4034 35.416 13.528L32.4667 16.4713C32.3426 16.5946 32.1749 16.6638 32 16.6638C31.8251 16.6638 31.6574 16.5946 31.5333 16.4713L28.5867 13.5313C28.5248 13.4687 28.4511 13.419 28.3698 13.385C28.2886 13.351 28.2014 13.3334 28.1133 13.3333H25.3333V1.33333H38.6667V13.3333Z"
        fill="#2A3845"
      />
      <path
        d="M27.3332 12.0001H36.6665C36.8433 12.0001 37.0129 11.9298 37.1379 11.8048C37.2629 11.6798 37.3332 11.5102 37.3332 11.3334C37.3332 11.1566 37.2629 10.987 37.1379 10.862C37.0129 10.737 36.8433 10.6667 36.6665 10.6667H35.9998V6.66675C35.9998 6.48994 35.9296 6.32037 35.8046 6.19534C35.6796 6.07032 35.51 6.00008 35.3332 6.00008C35.1564 6.00008 34.9868 6.07032 34.8618 6.19534C34.7367 6.32037 34.6665 6.48994 34.6665 6.66675V10.6667H33.3332V5.33341C33.3332 5.1566 33.2629 4.98703 33.1379 4.86201C33.0129 4.73699 32.8433 4.66675 32.6665 4.66675C32.4897 4.66675 32.3201 4.73699 32.1951 4.86201C32.0701 4.98703 31.9998 5.1566 31.9998 5.33341V10.6667H30.6665V8.00008C30.6665 7.82327 30.5963 7.6537 30.4712 7.52868C30.3462 7.40365 30.1766 7.33342 29.9998 7.33342C29.823 7.33342 29.6535 7.40365 29.5284 7.52868C29.4034 7.6537 29.3332 7.82327 29.3332 8.00008V10.6667H27.9998V3.33341C27.9998 3.1566 27.9296 2.98703 27.8046 2.86201C27.6796 2.73699 27.51 2.66675 27.3332 2.66675C27.1564 2.66675 26.9868 2.73699 26.8618 2.86201C26.7367 2.98703 26.6665 3.1566 26.6665 3.33341V11.3334C26.6665 11.5102 26.7367 11.6798 26.8618 11.8048C26.9868 11.9298 27.1564 12.0001 27.3332 12.0001Z"
        fill="#2A3845"
      />
      <path
        d="M32.6668 34H30.0002C29.8234 34 29.6538 34.0702 29.5288 34.1953C29.4037 34.3203 29.3335 34.4899 29.3335 34.6667C29.3335 34.8435 29.4037 35.013 29.5288 35.1381C29.6538 35.2631 29.8234 35.3333 30.0002 35.3333H32.6668C32.8436 35.3333 33.0132 35.2631 33.1382 35.1381C33.2633 35.013 33.3335 34.8435 33.3335 34.6667C33.3335 34.4899 33.2633 34.3203 33.1382 34.1953C33.0132 34.0702 32.8436 34 32.6668 34Z"
        fill="#2A3845"
      />
    </g>
    <defs>
      <clipPath id="clip0_5521_73209">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </>
)
export const InvoiceElectricityIcon = withSvg(
  <>
    <path
      d="M17.2796 2.1665C16.3518 2.1665 15.5996 4.40508 15.5996 7.1665H17.2796C18.0893 7.1665 18.4941 7.1665 18.7447 6.88696C18.9954 6.60741 18.9517 6.23928 18.8644 5.50301C18.6341 3.55936 18.0115 2.1665 17.2796 2.1665Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path
      d="M15.5999 7.21172V16.038C15.5999 17.2978 15.5999 17.9276 15.2149 18.1755C14.5859 18.5808 13.6134 17.731 13.1242 17.4226C12.72 17.1677 12.518 17.0403 12.2937 17.0329C12.0514 17.0249 11.8457 17.1472 11.409 17.4226L9.8166 18.4268C9.38702 18.6977 9.17227 18.8332 8.93327 18.8332C8.69428 18.8332 8.47948 18.6977 8.04993 18.4268L6.45754 17.4226C6.05339 17.1677 5.85132 17.0403 5.62704 17.0329C5.3847 17.0249 5.17904 17.1472 4.74233 17.4226C4.25323 17.731 3.28066 18.5808 2.65156 18.1755C2.2666 17.9276 2.2666 17.2978 2.2666 16.038V7.21172C2.2666 4.83338 2.2666 3.64421 2.99883 2.90536C3.73107 2.1665 4.90958 2.1665 7.2666 2.1665H17.2666"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.59961 5.5H12.2663" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.26628 8.8335H5.59961" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.875 9L10 12H13L11.125 15" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const InvoiceGasIcon = withSvg(
  <>
    <path
      d="M17.4798 2.1665C16.552 2.1665 15.7998 4.40508 15.7998 7.1665H17.4798C18.2895 7.1665 18.6943 7.1665 18.9449 6.88696C19.1956 6.60741 19.1519 6.23928 19.0646 5.50301C18.8343 3.55936 18.2117 2.1665 17.4798 2.1665Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path
      d="M15.8001 7.21172V16.038C15.8001 17.2978 15.8001 17.9276 15.4151 18.1755C14.786 18.5808 13.8135 17.731 13.3244 17.4226C12.9202 17.1677 12.7182 17.0403 12.4939 17.0329C12.2515 17.0249 12.0459 17.1472 11.6092 17.4226L10.0168 18.4268C9.58721 18.6977 9.37246 18.8332 9.13346 18.8332C8.89447 18.8332 8.67968 18.6977 8.25013 18.4268L6.65774 17.4226C6.25359 17.1677 6.05151 17.0403 5.82724 17.0329C5.5849 17.0249 5.37924 17.1472 4.94252 17.4226C4.45342 17.731 3.48086 18.5808 2.85176 18.1755C2.4668 17.9276 2.4668 17.2978 2.4668 16.038V7.21172C2.4668 4.83338 2.4668 3.64421 3.19903 2.90536C3.93126 2.1665 5.10977 2.1665 7.4668 2.1665H17.4668"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.7998 5.5H12.4665" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.46647 8.8335H5.7998" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.249 15C12.4917 15 13.499 13.9926 13.499 12.75C13.499 12.45 13.499 11.85 12.899 11.1C12.899 11.1 12.8691 11.9561 12.2769 11.8322C11.319 11.632 12.5556 9.75089 10.799 9C10.799 10.5 8.99902 10.95 8.99902 12.75C8.99902 13.9926 10.0064 15 11.249 15Z"
      stroke="#2A3845"
      strokeLinejoin="round"
    />
  </>
)
export const UserCircleIcon = withSvg(
  <>
    <path
      d="M6.48579 14.2595C5.56881 14.786 3.16454 15.8611 4.6289 17.2063C5.34424 17.8635 6.14093 18.3335 7.14256 18.3335H12.8581C13.8597 18.3335 14.6564 17.8635 15.3717 17.2063C16.8361 15.8611 14.4318 14.786 13.5148 14.2595C11.3646 13.0248 8.63608 13.0248 6.48579 14.2595Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9163 8.33317C12.9163 9.944 11.6105 11.2498 9.99967 11.2498C8.38884 11.2498 7.08301 9.944 7.08301 8.33317C7.08301 6.72234 8.38884 5.4165 9.99967 5.4165C11.6105 5.4165 12.9163 6.72234 12.9163 8.33317Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path
      d="M2.37866 13.3332C1.92117 12.3052 1.66699 11.1673 1.66699 9.97034C1.66699 5.38425 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.38425 18.3337 9.97034C18.3337 11.1673 18.0795 12.3052 17.622 13.3332"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </>
)

export const LightningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.66126 9.99709L10.66 3.25989C11.0509 2.73298 11.7838 3.06093 11.7838 3.7628V8.97742C11.7838 9.39792 12.0711 9.73875 12.4256 9.73875H14.8569C15.4092 9.73875 15.7036 10.5112 15.3388 11.0029L10.34 17.7401C9.94908 18.267 9.21625 17.9391 9.21625 17.2372V12.0226C9.21625 11.6021 8.92892 11.2613 8.57443 11.2613H6.14311C5.59079 11.2613 5.29638 10.4888 5.66126 9.99709Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FlameIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.75 18.8332C14.2017 18.8332 17 16.0349 17 12.5832C17 11.7498 17 10.0832 15.3333 7.99984C15.3333 7.99984 15.2503 10.3778 13.6052 10.0338C10.9442 9.4775 14.3792 4.2523 9.5 2.1665C9.5 6.33317 4.5 7.58317 4.5 12.5832C4.5 16.0349 7.29822 18.8332 10.75 18.8332Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M10.7497 16.3341C12.3605 16.3341 13.6663 14.6552 13.6663 12.5841C10.9997 13.5841 10.0553 11.2814 9.91634 9.6665C8.71156 10.1275 7.83301 12.0212 7.83301 12.9998C7.83301 15.0709 9.13884 16.3341 10.7497 16.3341Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
)

export const ReactiveEnergyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.7192 7.875C18.2102 6.17518 18.0723 4.69962 17.1863 3.81363C15.312 1.93925 10.7989 3.41335 7.10614 7.10613C6.71164 7.50061 6.34248 7.90446 6 8.31346M15 12.6865C14.6575 13.0955 14.2883 13.4994 13.8938 13.8938C10.2011 17.5867 5.68802 19.0607 3.81363 17.1863C2.86308 16.2358 2.77368 14.6067 3.3981 12.75"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0625 8.25L9.60324 9.97529C9.42507 10.2063 9.33607 10.3218 9.39124 10.4109C9.44641 10.5 9.60699 10.5 9.92807 10.5H11.0719C11.393 10.5 11.5536 10.5 11.6087 10.5891C11.6639 10.6782 11.5748 10.7937 11.3967 11.0247L9.92807 12.75"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.625 15.2549C8.10954 14.8428 7.60048 14.3883 7.10613 13.8938C3.41335 10.2011 1.93925 5.68802 3.81363 3.81363C4.76418 2.86308 6.39335 2.77368 8.25 3.3981M12.375 17.4673C14.3859 18.2344 16.1723 18.2004 17.1863 17.1863C19.0607 15.312 17.5867 10.7989 13.8938 7.10614C13.3995 6.61178 12.8905 6.15718 12.375 5.74506"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MountainIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.0837 17.1668H2.41699L5.10413 9.46325C6.41328 5.71007 7.06786 3.8335 8.25033 3.8335C9.36474 3.8335 10.0102 5.50016 11.1767 8.8335"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 17.1667H19.0833L15.2555 11.0487C13.9838 9.01625 13.348 8 12.4167 8C11.4853 8 10.8495 9.01625 9.57783 11.0487L8.35698 13"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FuelBoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.92592 4.25H7.16634C5.59499 4.25 4.80932 4.25 4.32117 4.73816C3.83301 5.22631 3.83301 6.01198 3.83301 7.58333V13.8333C3.83301 16.1903 3.83301 17.3688 4.56524 18.1011C5.29747 18.8333 6.47598 18.8333 8.83301 18.8333H12.1663C14.5233 18.8333 15.7018 18.8333 16.4341 18.1011C17.1663 17.3688 17.1663 16.1903 17.1663 13.8333V11.7036C17.1663 9.69883 17.1663 8.69652 16.6685 7.89101C16.1707 7.0855 15.2742 6.63724 13.4811 5.74071L11.9073 4.95382C11.2067 4.6035 10.8563 4.42834 10.4786 4.33917C10.1009 4.25 9.70926 4.25 8.92592 4.25Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4997 15.5002C11.4202 15.5002 12.1663 14.8006 12.1663 13.9377C12.1663 12.896 10.4997 11.3335 10.4997 11.3335C10.4997 11.3335 8.83301 12.896 8.83301 13.9377C8.83301 14.8006 9.57917 15.5002 10.4997 15.5002Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.917 7.1665L14.2503 8.83317" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.5 4.24984V3.62484C5.5 3.03965 5.5 2.74705 5.64044 2.53686C5.70124 2.44587 5.77937 2.36775 5.87036 2.30695C6.08054 2.1665 6.37314 2.1665 6.95833 2.1665C7.54353 2.1665 7.83612 2.1665 8.04631 2.30695C8.1373 2.36775 8.21542 2.44587 8.27622 2.53686C8.41667 2.74705 8.41667 3.03965 8.41667 3.62484V4.24984"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BoxCheckedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.25 6.3335V10.5002M3.25 6.3335C3.25 8.88725 3.25 14.4787 3.25 14.8012C3.25 15.9533 4.87137 16.6382 8.11411 18.0081C9.41683 18.5583 10.0682 18.8335 10.75 18.8335V9.9625"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.25 16.3333C13.25 16.3333 13.9792 16.3333 14.7083 18C14.7083 18 17.0245 13.8333 19.0833 13"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.68827 8.57599L5.25393 7.39805C3.91797 6.75159 3.25 6.42836 3.25 5.9165C3.25 5.40465 3.91797 5.08142 5.25393 4.43496L7.68827 3.25702C9.19067 2.53001 9.94192 2.1665 10.75 2.1665C11.5581 2.1665 12.3093 2.53 13.8117 3.25702L16.2461 4.43496C17.582 5.08142 18.25 5.40465 18.25 5.9165C18.25 6.42836 17.582 6.75159 16.2461 7.39805L13.8117 8.57599C12.3093 9.303 11.5581 9.6665 10.75 9.6665C9.94192 9.6665 9.19067 9.303 7.68827 8.57599Z"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.75 10.5L7.41667 11.3333" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.9163 3.8335L6.58301 8.00016" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const EnergyRefreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8773 17.0974C17.0104 15.6791 18.4163 13.2538 18.4163 10.5002C18.4163 6.1279 14.8719 2.5835 10.4997 2.5835C9.89501 2.5835 9.30617 2.65128 8.74042 2.77967M14.8773 17.0974V14.6668M14.8773 17.0974H17.583M6.10152 3.91662C3.97988 5.3368 2.58301 7.75535 2.58301 10.5002C2.58301 14.8724 6.12742 18.4168 10.4997 18.4168C11.1043 18.4168 11.6932 18.3491 12.2589 18.2207M6.10152 3.91662V6.3335M6.10152 3.91662H3.41634"
      stroke="#2A3845"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.9167 6.3335L8 10.5002H13L10.0833 14.6668" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const ThreeDotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.9163 5.41667C12.9163 7.0275 11.6105 8.33333 9.99967 8.33333C8.38884 8.33333 7.08301 7.0275 7.08301 5.41667C7.08301 3.80583 8.38884 2.5 9.99967 2.5C11.6105 2.5 12.9163 3.80583 12.9163 5.41667Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path
      d="M18.3333 14.5832C18.3333 16.194 17.0275 17.4998 15.4167 17.4998C13.8058 17.4998 12.5 16.194 12.5 14.5832C12.5 12.9723 13.8058 11.6665 15.4167 11.6665C17.0275 11.6665 18.3333 12.9723 18.3333 14.5832Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
    <path
      d="M7.50033 14.5832C7.50033 16.194 6.19449 17.4998 4.58366 17.4998C2.97283 17.4998 1.66699 16.194 1.66699 14.5832C1.66699 12.9723 2.97283 11.6665 4.58366 11.6665C6.19449 11.6665 7.50033 12.9723 7.50033 14.5832Z"
      stroke="#2A3845"
      strokeWidth="1.25"
    />
  </svg>
)

export const ExcelDownloadIcon = withSvg(
  <>
    <path
      d="M2.40002 2.4C2.40002 1.07452 3.47454 0 4.80002 0H14.4L21.6 7.2V21.6C21.6 22.9255 20.5255 24 19.2 24H4.80002C3.47454 24 2.40002 22.9255 2.40002 21.6V2.4Z"
      fill="#099250"
    />
    <path opacity="0.3" d="M14.4 0L21.6 7.2H16.8C15.4745 7.2 14.4 6.12548 14.4 4.8V0Z" fill="white" />
    <g clipPath="url(#clip0_4803_23820)">
      <path
        d="M7.67999 14.88H16.32M7.67999 14.88V12.96C7.67999 12.4298 8.1098 12 8.63999 12H10.56M7.67999 14.88V16.8C7.67999 17.3302 8.1098 17.76 8.63999 17.76H10.56M16.32 14.88V16.8C16.32 17.3302 15.8902 17.76 15.36 17.76H10.56M16.32 14.88V12.96C16.32 12.4298 15.8902 12 15.36 12H10.56M10.56 12V17.76"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4803_23820">
        <rect width="9.6" height="9.6" fill="white" transform="translate(7.20001 9.59998)" />
      </clipPath>
    </defs>
  </>
)

export const PdfDownloadIcon = withSvg(
  <>
    <path
      d="M2.39999 4C2.39999 1.79086 4.19086 0 6.39999 0H14.4L21.6 7.2V20C21.6 22.2091 19.8091 24 17.6 24H6.39999C4.19085 24 2.39999 22.2091 2.39999 20V4Z"
      fill="#D92D20"
    />
    <path opacity="0.3" d="M14.4 0L21.6 7.2H18.4C16.1909 7.2 14.4 5.40914 14.4 3.2V0Z" fill="white" />
    <path
      d="M15.0447 15.1168C14.4459 15.1168 13.6964 15.2212 13.4513 15.258C12.4365 14.1983 12.1478 13.5959 12.0828 13.4353C12.1708 13.2092 12.477 12.3502 12.5205 11.2469C12.542 10.6946 12.4253 10.2818 12.1736 10.0202C11.9224 9.75896 11.6183 9.73865 11.5311 9.73865C11.2253 9.73865 10.7124 9.89327 10.7124 10.9287C10.7124 11.8271 11.1312 12.7804 11.247 13.0267C10.637 14.803 9.98206 16.0189 9.84298 16.269C7.3917 17.1919 7.20001 18.0843 7.20001 18.3372C7.20001 18.7917 7.52369 19.063 8.06584 19.063C9.38305 19.063 10.5851 16.8516 10.7838 16.4676C11.7194 16.0948 12.9715 15.8639 13.2898 15.8088C14.2029 16.6786 15.2589 16.9107 15.6974 16.9107C16.0273 16.9107 16.8 16.9107 16.8 16.1162C16.8 15.3785 15.8545 15.1168 15.0447 15.1168ZM14.9812 15.6383C15.6927 15.6383 15.8808 15.8736 15.8808 15.998C15.8808 16.0761 15.8511 16.3308 15.4698 16.3308C15.1278 16.3308 14.5374 16.1331 13.9564 15.7043C14.1987 15.6725 14.5572 15.6383 14.9812 15.6383ZM11.4938 10.2442C11.5586 10.2442 11.6013 10.265 11.6365 10.3138C11.8412 10.5978 11.6762 11.5256 11.4754 12.2516C11.2815 11.6291 11.136 10.6738 11.3407 10.3378C11.3807 10.2722 11.4265 10.2442 11.4938 10.2442ZM11.1482 15.8014C11.4058 15.281 11.6945 14.5226 11.8518 14.0937C12.1665 14.6204 12.5897 15.1095 12.8345 15.3746C12.0723 15.5353 11.4956 15.6958 11.1482 15.8014ZM7.71169 18.4066C7.69472 18.3865 7.69221 18.3441 7.705 18.2931C7.73182 18.1864 7.93677 17.6573 9.4191 16.9942C9.20685 17.3285 8.87503 17.8062 8.5105 18.1631C8.25391 18.4033 8.0541 18.5251 7.91664 18.5251C7.86746 18.5251 7.7997 18.5117 7.71169 18.4066Z"
      fill="white"
    />
  </>
)

export const EditDrawIcon = withSvg(
  <>
    <path
      d="M12.7094 2.37979C13.1499 1.93934 13.3701 1.71911 13.6141 1.6138C13.9656 1.46207 14.3641 1.46207 14.7156 1.6138C14.9595 1.71911 15.1798 1.93934 15.6202 2.37979C16.0607 2.82024 16.2809 3.04046 16.3862 3.28444C16.538 3.63593 16.538 4.03443 16.3862 4.38592C16.2809 4.62989 16.0607 4.85012 15.6202 5.29057L11.854 9.05678C10.9261 9.98468 10.4622 10.4486 9.8811 10.7235C9.3 10.9984 8.64705 11.0628 7.34117 11.1917L6.75 11.25L6.80833 10.6589C6.93718 9.35295 7.00162 8.7 7.27651 8.1189C7.55138 7.5378 8.01533 7.07387 8.94323 6.14598L12.7094 2.37979Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 11.25H2.8125C2.08763 11.25 1.5 11.8376 1.5 12.5625C1.5 13.2874 2.08763 13.875 2.8125 13.875H9.9375C10.6624 13.875 11.25 14.4626 11.25 15.1875C11.25 15.9124 10.6624 16.5 9.9375 16.5H8.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const ElectricHome = ({ size = 18, color, viewBox = "0 0 18 18", ...props }: IconProps) => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} width={size} height={size} fill="none" color={color} {...props}>
      <path
        d="M15 6.43945V10.126C15 12.9544 15 14.3687 14.1213 15.2473C13.5152 15.8535 12.6542 16.0415 11.25 16.0998M3 6.43945V10.126C3 12.9544 3 14.3687 3.87868 15.2473C4.67599 16.0447 5.91422 16.1185 8.24985 16.1254C8.66407 16.1266 9 15.7903 9 15.376V13.126"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 7.87497L13.2427 4.75161C11.2427 2.83387 10.2427 1.875 9 1.875C7.75732 1.875 6.75736 2.83387 4.75736 4.75161L1.5 7.87497"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M10.5005 6.75V8.62497M7.50051 8.62497V6.75M6.3789 9.28497C6.34947 8.92879 6.65677 8.62497 7.0464 8.62497H10.9576C11.3472 8.62497 11.6545 8.92879 11.6251 9.28497L11.5446 10.258C11.4868 10.9575 11.2337 11.6317 10.8097 12.2157L10.5469 12.5777C10.2987 12.9195 9.88033 13.125 9.43236 13.125H8.57158C8.12361 13.125 7.70533 12.9195 7.45707 12.5777L7.19422 12.2157C6.7702 11.6317 6.51714 10.9575 6.45933 10.258L6.3789 9.28497Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  </>
)
export const BubbleChatEdit = ({ size = 18, color, viewBox = "0 0 18 18", ...props }: IconProps) => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} width={size} height={size} fill="none" color={color} {...props}>
      <path d="M8.99662 9H9.00338M6 9H6.00673" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.5 8.67502C16.5 12.6374 13.1417 15.85 9 15.85C8.51303 15.8507 8.0274 15.8057 7.54905 15.7159C7.20475 15.6512 7.03258 15.6188 6.9124 15.6372C6.7922 15.6556 6.62189 15.7462 6.28124 15.9273C5.31761 16.4398 4.19396 16.6207 3.11333 16.4197C3.52406 15.9145 3.80456 15.3084 3.92834 14.6586C4.00334 14.2611 3.8175 13.875 3.53917 13.5923C2.275 12.3086 1.5 10.5788 1.5 8.67502C1.5 4.71268 4.85833 1.5 9 1.5C9.51367 1.5 10.0153 1.54943 10.5 1.64357"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6294 1.85685L16.1486 2.37613C16.588 2.81546 16.588 3.52778 16.1486 3.96711L13.4281 6.73886C13.2141 6.95288 12.9404 7.09715 12.6428 7.15271L10.9568 7.51871C10.6905 7.57654 10.4534 7.34016 10.5105 7.07378L10.8694 5.39729C10.925 5.09978 11.0692 4.82603 11.2832 4.61201L14.0384 1.85685C14.4777 1.41751 15.1901 1.41751 15.6294 1.85685Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </>
)

export const TickIcon = (props: IconProps) => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.91699 12.083C4.91699 12.083 6.16699 12.083 7.83366 14.9997C7.83366 14.9997 12.466 7.36078 16.5837 5.83301"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Passport3 = (props: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 10C2.5 6.46447 2.5 4.6967 3.72039 3.59835C4.94077 2.5 6.90497 2.5 10.8333 2.5C14.7617 2.5 16.7259 2.5 17.9462 3.59835C19.1667 4.6967 19.1667 6.46447 19.1667 10C19.1667 13.5355 19.1667 15.3033 17.9462 16.4017C16.7259 17.5 14.7617 17.5 10.8333 17.5C6.90497 17.5 4.94077 17.5 3.72039 16.4017C2.5 15.3033 2.5 13.5355 2.5 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.68342 5.99668C7.77366 5.86093 7.93937 5.80149 8.09212 5.85008C8.24487 5.89868 8.34902 6.04396 8.349 6.20841V8.64217H10.4687C10.6039 8.64218 10.7281 8.71919 10.7912 8.84224C10.8543 8.96528 10.846 9.11415 10.7697 9.22898L8.14992 13.1699C8.05968 13.3057 7.89396 13.3651 7.74121 13.3165C7.58846 13.268 7.48431 13.1227 7.48434 12.9582V10.5244H5.36464C5.22938 10.5244 5.10524 10.4474 5.04213 10.3244C4.97902 10.2013 4.98731 10.0525 5.06367 9.93763L7.68342 5.99668Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.334 8.33331H15.834" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.334 11.6667H15.834" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export const EditCommentIcon = (props: IconProps) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.99662 9H9.00338M6 9H6.00673" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.5 8.67502C16.5 12.6374 13.1417 15.85 9 15.85C8.51303 15.8507 8.0274 15.8057 7.54905 15.7159C7.20475 15.6512 7.03258 15.6188 6.9124 15.6372C6.7922 15.6556 6.62189 15.7462 6.28124 15.9273C5.31761 16.4398 4.19396 16.6207 3.11333 16.4197C3.52406 15.9145 3.80456 15.3084 3.92834 14.6586C4.00334 14.2611 3.8175 13.875 3.53917 13.5923C2.275 12.3086 1.5 10.5788 1.5 8.67502C1.5 4.71268 4.85833 1.5 9 1.5C9.51367 1.5 10.0153 1.54943 10.5 1.64357"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6294 1.85685L16.1486 2.37613C16.588 2.81546 16.588 3.52778 16.1486 3.96711L13.4281 6.73886C13.2141 6.95288 12.9404 7.09715 12.6428 7.15271L10.9568 7.51871C10.6905 7.57654 10.4534 7.34016 10.5105 7.07378L10.8694 5.39729C10.925 5.09978 11.0692 4.82603 11.2832 4.61201L14.0384 1.85685C14.4777 1.41751 15.1901 1.41751 15.6294 1.85685Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const HomeAndPlugIcon = (props: IconProps) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 6.43872V10.1253C15 12.9537 15 14.368 14.1213 15.2466C13.5152 15.8528 12.6542 16.0408 11.25 16.0991M3 6.43872V10.1253C3 12.9537 3 14.368 3.87868 15.2466C4.67599 16.0439 5.91422 16.1178 8.24985 16.1246C8.66407 16.1258 9 15.7895 9 15.3753V13.1253"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 7.87497L13.2427 4.75161C11.2427 2.83387 10.2427 1.875 9 1.875C7.75732 1.875 6.75736 2.83387 4.75736 4.75161L1.5 7.87497"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
    <path
      d="M10.5005 6.75V8.62497M7.50051 8.62497V6.75M6.3789 9.28497C6.34947 8.92879 6.65677 8.62497 7.0464 8.62497H10.9576C11.3472 8.62497 11.6545 8.92879 11.6251 9.28497L11.5446 10.258C11.4868 10.9575 11.2337 11.6317 10.8097 12.2157L10.5469 12.5777C10.2987 12.9195 9.88033 13.125 9.43236 13.125H8.57158C8.12361 13.125 7.70533 12.9195 7.45707 12.5777L7.19422 12.2157C6.7702 11.6317 6.51714 10.9575 6.45933 10.258L6.3789 9.28497Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </svg>
)

export const ObjectionCommentIcon = ({ color = "#0353DC", ...props }: IconProps & { color?: string }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.5" y="0.5" width="35" height="35" rx="7.5" fill={color} fill-opacity="0.1" />
    <rect x="0.5" y="0.5" width="35" height="35" rx="7.5" stroke={color} />
    <path
      d="M20.5 9.66669L23.4167 12.5834M23.4167 12.5834L26.3333 15.5M23.4167 12.5834L26.3333 9.66669M23.4167 12.5834L20.5 15.5"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0817 24.25C11.9983 24.1434 11.1866 23.818 10.6423 23.2737C9.66602 22.2974 9.66602 20.726 9.66602 17.5833V17.1667C9.66602 14.024 9.66602 12.4526 10.6423 11.4763C11.6186 10.5 13.19 10.5 16.3327 10.5H17.5827M13.416 23C13.2448 23.8349 12.4808 25.6388 13.2624 26.2209C13.671 26.5182 14.3221 26.2007 15.6242 25.5657C16.5381 25.1201 17.4628 24.6091 18.4615 24.3792C18.8269 24.2959 19.1989 24.2604 19.666 24.25C22.8087 24.25 24.3801 24.25 25.3563 23.2737C26.2885 22.3415 26.3307 20.8669 26.3326 18"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path d="M14.666 19.6667H19.666M14.666 15.5H17.166" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const TickIcon2 = (props: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.16602 12.0833C4.16602 12.0833 5.41602 12.0833 7.08268 15C7.08268 15 11.715 7.36109 15.8327 5.83331"
      stroke="#0DAB0A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const InformationCircleIcon = (props: IconProps) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.1174 12C22.1174 6.47715 17.6403 2 12.1174 2C6.59458 2 2.11743 6.47715 2.11743 12C2.11743 17.5228 6.59458 22 12.1174 22C17.6403 22 22.1174 17.5228 22.1174 12Z"
      stroke={props.stroke}
      strokeWidth="1.5"
    />
    <path
      d="M12.3596 17V12C12.3596 11.5286 12.3596 11.2929 12.2132 11.1464C12.0667 11 11.831 11 11.3596 11"
      stroke={props.stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.1094 8H12.1184" stroke={props.stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const TrickIcon = (props: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.1665 12.0833C4.1665 12.0833 5.4165 12.0833 7.08317 15C7.08317 15 11.7155 7.3611 15.8332 5.83333"
      stroke="#0DAB0A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
